//#region src/js/product.js
/*! For license information please see product.js.LICENSE.txt */
(() => {
	"use strict";
	var t = {
		619: (t, e, i) => {
			i.d(e, { A: () => r });
			var s = i(601), n = i.n(s), o = i(314), a = i.n(o)()(n());
			a.push([
				t.id,
				"/*! PhotoSwipe main CSS by Dmytro Semenov | photoswipe.com */\n\n.pswp {\n  --pswp-bg: #000;\n  --pswp-placeholder-bg: #222;\n  \n\n  --pswp-root-z-index: 100000;\n  \n  --pswp-preloader-color: rgba(79, 79, 79, 0.4);\n  --pswp-preloader-color-secondary: rgba(255, 255, 255, 0.9);\n  \n  /* defined via js:\n  --pswp-transition-duration: 333ms; */\n  \n  --pswp-icon-color: #fff;\n  --pswp-icon-color-secondary: #4f4f4f;\n  --pswp-icon-stroke-color: #4f4f4f;\n  --pswp-icon-stroke-width: 2px;\n\n  --pswp-error-text-color: var(--pswp-icon-color);\n}\n\n\n/*\n	Styles for basic PhotoSwipe (pswp) functionality (sliding area, open/close transitions)\n*/\n\n.pswp {\n	position: fixed;\n	top: 0;\n	left: 0;\n	width: 100%;\n	height: 100%;\n	z-index: var(--pswp-root-z-index);\n	display: none;\n	touch-action: none;\n	outline: 0;\n	opacity: 0.003;\n	contain: layout style size;\n	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n/* Prevents focus outline on the root element,\n  (it may be focused initially) */\n.pswp:focus {\n  outline: 0;\n}\n\n.pswp * {\n  box-sizing: border-box;\n}\n\n.pswp img {\n  max-width: none;\n}\n\n.pswp--open {\n	display: block;\n}\n\n.pswp,\n.pswp__bg {\n	transform: translateZ(0);\n	will-change: opacity;\n}\n\n.pswp__bg {\n  opacity: 0.005;\n	background: var(--pswp-bg);\n}\n\n.pswp,\n.pswp__scroll-wrap {\n	overflow: hidden;\n}\n\n.pswp__scroll-wrap,\n.pswp__bg,\n.pswp__container,\n.pswp__item,\n.pswp__content,\n.pswp__img,\n.pswp__zoom-wrap {\n	position: absolute;\n	top: 0;\n	left: 0;\n	width: 100%;\n	height: 100%;\n}\n\n.pswp__img,\n.pswp__zoom-wrap {\n	width: auto;\n	height: auto;\n}\n\n.pswp--click-to-zoom.pswp--zoom-allowed .pswp__img {\n	cursor: -webkit-zoom-in;\n	cursor: -moz-zoom-in;\n	cursor: zoom-in;\n}\n\n.pswp--click-to-zoom.pswp--zoomed-in .pswp__img {\n	cursor: move;\n	cursor: -webkit-grab;\n	cursor: -moz-grab;\n	cursor: grab;\n}\n\n.pswp--click-to-zoom.pswp--zoomed-in .pswp__img:active {\n  cursor: -webkit-grabbing;\n  cursor: -moz-grabbing;\n  cursor: grabbing;\n}\n\n/* :active to override grabbing cursor */\n.pswp--no-mouse-drag.pswp--zoomed-in .pswp__img,\n.pswp--no-mouse-drag.pswp--zoomed-in .pswp__img:active,\n.pswp__img {\n	cursor: -webkit-zoom-out;\n	cursor: -moz-zoom-out;\n	cursor: zoom-out;\n}\n\n\n/* Prevent selection and tap highlights */\n.pswp__container,\n.pswp__img,\n.pswp__button,\n.pswp__counter {\n	-webkit-user-select: none;\n	-moz-user-select: none;\n	-ms-user-select: none;\n	user-select: none;\n}\n\n.pswp__item {\n	/* z-index for fade transition */\n	z-index: 1;\n	overflow: hidden;\n}\n\n.pswp__hidden {\n	display: none !important;\n}\n\n/* Allow to click through pswp__content element, but not its children */\n.pswp__content {\n  pointer-events: none;\n}\n.pswp__content > * {\n  pointer-events: auto;\n}\n\n\n/*\n\n  PhotoSwipe UI\n\n*/\n\n/*\n	Error message appears when image is not loaded\n	(JS option errorMsg controls markup)\n*/\n.pswp__error-msg-container {\n  display: grid;\n}\n.pswp__error-msg {\n	margin: auto;\n	font-size: 1em;\n	line-height: 1;\n	color: var(--pswp-error-text-color);\n}\n\n/*\nclass pswp__hide-on-close is applied to elements that\nshould hide (for example fade out) when PhotoSwipe is closed\nand show (for example fade in) when PhotoSwipe is opened\n */\n.pswp .pswp__hide-on-close {\n	opacity: 0.005;\n	will-change: opacity;\n	transition: opacity var(--pswp-transition-duration) cubic-bezier(0.4, 0, 0.22, 1);\n	z-index: 10; /* always overlap slide content */\n	pointer-events: none; /* hidden elements should not be clickable */\n}\n\n/* class pswp--ui-visible is added when opening or closing transition starts */\n.pswp--ui-visible .pswp__hide-on-close {\n	opacity: 1;\n	pointer-events: auto;\n}\n\n/* <button> styles, including css reset */\n.pswp__button {\n	position: relative;\n	display: block;\n	width: 50px;\n	height: 60px;\n	padding: 0;\n	margin: 0;\n	overflow: hidden;\n	cursor: pointer;\n	background: none;\n	border: 0;\n	box-shadow: none;\n	opacity: 0.85;\n	-webkit-appearance: none;\n	-webkit-touch-callout: none;\n}\n\n.pswp__button:hover,\n.pswp__button:active,\n.pswp__button:focus {\n  transition: none;\n  padding: 0;\n  background: none;\n  border: 0;\n  box-shadow: none;\n  opacity: 1;\n}\n\n.pswp__button:disabled {\n  opacity: 0.3;\n  cursor: auto;\n}\n\n.pswp__icn {\n  fill: var(--pswp-icon-color);\n  color: var(--pswp-icon-color-secondary);\n}\n\n.pswp__icn {\n  position: absolute;\n  top: 14px;\n  left: 9px;\n  width: 32px;\n  height: 32px;\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.pswp__icn-shadow {\n  stroke: var(--pswp-icon-stroke-color);\n  stroke-width: var(--pswp-icon-stroke-width);\n  fill: none;\n}\n\n.pswp__icn:focus {\n	outline: 0;\n}\n\n/*\n	div element that matches size of large image,\n	large image loads on top of it,\n	used when msrc is not provided\n*/\ndiv.pswp__img--placeholder,\n.pswp__img--with-bg {\n	background: var(--pswp-placeholder-bg);\n}\n\n.pswp__top-bar {\n	position: absolute;\n	left: 0;\n	top: 0;\n	width: 100%;\n	height: 60px;\n	display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n	z-index: 10;\n\n	/* allow events to pass through top bar itself */\n	pointer-events: none !important;\n}\n.pswp__top-bar > * {\n  pointer-events: auto;\n  /* this makes transition significantly more smooth,\n     even though inner elements are not animated */\n  will-change: opacity;\n}\n\n\n/*\n\n  Close button\n\n*/\n.pswp__button--close {\n  margin-right: 6px;\n}\n\n\n/*\n\n  Arrow buttons\n\n*/\n.pswp__button--arrow {\n  position: absolute;\n  top: 0;\n  width: 75px;\n  height: 100px;\n  top: 50%;\n  margin-top: -50px;\n}\n\n.pswp__button--arrow:disabled {\n  display: none;\n  cursor: default;\n}\n\n.pswp__button--arrow .pswp__icn {\n  top: 50%;\n  margin-top: -30px;\n  width: 60px;\n  height: 60px;\n  background: none;\n  border-radius: 0;\n}\n\n.pswp--one-slide .pswp__button--arrow {\n  display: none;\n}\n\n/* hide arrows on touch screens */\n.pswp--touch .pswp__button--arrow {\n  visibility: hidden;\n}\n\n/* show arrows only after mouse was used */\n.pswp--has_mouse .pswp__button--arrow {\n  visibility: visible;\n}\n\n.pswp__button--arrow--prev {\n  right: auto;\n  left: 0px;\n}\n\n.pswp__button--arrow--next {\n  right: 0px;\n}\n.pswp__button--arrow--next .pswp__icn {\n  left: auto;\n  right: 14px;\n  /* flip horizontally */\n  transform: scale(-1, 1);\n}\n\n/*\n\n  Zoom button\n\n*/\n.pswp__button--zoom {\n  display: none;\n}\n\n.pswp--zoom-allowed .pswp__button--zoom {\n  display: block;\n}\n\n/* \"+\" => \"-\" */\n.pswp--zoomed-in .pswp__zoom-icn-bar-v {\n  display: none;\n}\n\n\n/*\n\n  Loading indicator\n\n*/\n.pswp__preloader {\n  position: relative;\n  overflow: hidden;\n  width: 50px;\n  height: 60px;\n  margin-right: auto;\n}\n\n.pswp__preloader .pswp__icn {\n  opacity: 0;\n  transition: opacity 0.2s linear;\n  animation: pswp-clockwise 600ms linear infinite;\n}\n\n.pswp__preloader--active .pswp__icn {\n  opacity: 0.85;\n}\n\n@keyframes pswp-clockwise {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n\n/*\n\n  \"1 of 10\" counter\n\n*/\n.pswp__counter {\n  height: 30px;\n  margin-top: 15px;\n  margin-inline-start: 20px;\n  font-size: 14px;\n  line-height: 30px;\n  color: var(--pswp-icon-color);\n  text-shadow: 1px 1px 3px var(--pswp-icon-color-secondary);\n  opacity: 0.85;\n}\n\n.pswp--one-slide .pswp__counter {\n  display: none;\n}\n",
				""
			]);
			const r = a;
		},
		314: (t) => {
			t.exports = function(t) {
				var e = [];
				return e.toString = function() {
					return this.map(function(e) {
						var i = "", s = void 0 !== e[5];
						return e[4] && (i += "@supports (".concat(e[4], ") {")), e[2] && (i += "@media ".concat(e[2], " {")), s && (i += "@layer".concat(e[5].length > 0 ? " ".concat(e[5]) : "", " {")), i += t(e), s && (i += "}"), e[2] && (i += "}"), e[4] && (i += "}"), i;
					}).join("");
				}, e.i = function(t, i, s, n, o) {
					"string" == typeof t && (t = [[
						null,
						t,
						void 0
					]]);
					var a = {};
					if (s) for (var r = 0; r < this.length; r++) {
						var h = this[r][0];
						null != h && (a[h] = !0);
					}
					for (var l = 0; l < t.length; l++) {
						var p = [].concat(t[l]);
						s && a[p[0]] || (void 0 !== o && (void 0 === p[5] || (p[1] = "@layer".concat(p[5].length > 0 ? " ".concat(p[5]) : "", " {").concat(p[1], "}")), p[5] = o), i && (p[2] ? (p[1] = "@media ".concat(p[2], " {").concat(p[1], "}"), p[2] = i) : p[2] = i), n && (p[4] ? (p[1] = "@supports (".concat(p[4], ") {").concat(p[1], "}"), p[4] = n) : p[4] = "".concat(n)), e.push(p));
					}
				}, e;
			};
		},
		601: (t) => {
			t.exports = function(t) {
				return t[1];
			};
		},
		72: (t) => {
			var e = [];
			function i(t) {
				for (var i = -1, s = 0; s < e.length; s++) if (e[s].identifier === t) {
					i = s;
					break;
				}
				return i;
			}
			function s(t, s) {
				for (var o = {}, a = [], r = 0; r < t.length; r++) {
					var h = t[r], l = s.base ? h[0] + s.base : h[0], p = o[l] || 0, d = "".concat(l, " ").concat(p);
					o[l] = p + 1;
					var c = i(d), m = {
						css: h[1],
						media: h[2],
						sourceMap: h[3],
						supports: h[4],
						layer: h[5]
					};
					if (-1 !== c) e[c].references++, e[c].updater(m);
					else {
						var u = n(m, s);
						s.byIndex = r, e.splice(r, 0, {
							identifier: d,
							updater: u,
							references: 1
						});
					}
					a.push(d);
				}
				return a;
			}
			function n(t, e) {
				var i = e.domAPI(e);
				return i.update(t), function(e) {
					if (e) {
						if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap && e.supports === t.supports && e.layer === t.layer) return;
						i.update(t = e);
					} else i.remove();
				};
			}
			t.exports = function(t, n) {
				var o = s(t = t || [], n = n || {});
				return function(t) {
					t = t || [];
					for (var a = 0; a < o.length; a++) {
						var r = i(o[a]);
						e[r].references--;
					}
					for (var h = s(t, n), l = 0; l < o.length; l++) {
						var p = i(o[l]);
						0 === e[p].references && (e[p].updater(), e.splice(p, 1));
					}
					o = h;
				};
			};
		},
		659: (t) => {
			var e = {};
			t.exports = function(t, i) {
				var s = (function(t) {
					if (void 0 === e[t]) {
						var i = document.querySelector(t);
						if (window.HTMLIFrameElement && i instanceof window.HTMLIFrameElement) try {
							i = i.contentDocument.head;
						} catch (t) {
							i = null;
						}
						e[t] = i;
					}
					return e[t];
				})(t);
				if (!s) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
				s.appendChild(i);
			};
		},
		540: (t) => {
			t.exports = function(t) {
				var e = document.createElement("style");
				return t.setAttributes(e, t.attributes), t.insert(e, t.options), e;
			};
		},
		56: (t, e, i) => {
			t.exports = function(t) {
				var e = i.nc;
				e && t.setAttribute("nonce", e);
			};
		},
		825: (t) => {
			t.exports = function(t) {
				if ("undefined" == typeof document) return {
					update: function() {},
					remove: function() {}
				};
				var e = t.insertStyleElement(t);
				return {
					update: function(i) {
						(function(t, e, i) {
							var s = "";
							i.supports && (s += "@supports (".concat(i.supports, ") {")), i.media && (s += "@media ".concat(i.media, " {"));
							var n = void 0 !== i.layer;
							n && (s += "@layer".concat(i.layer.length > 0 ? " ".concat(i.layer) : "", " {")), s += i.css, n && (s += "}"), i.media && (s += "}"), i.supports && (s += "}");
							var o = i.sourceMap;
							o && "undefined" != typeof btoa && (s += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o)))), " */")), e.styleTagTransform(s, t, e.options);
						})(e, t, i);
					},
					remove: function() {
						(function(t) {
							if (null === t.parentNode) return !1;
							t.parentNode.removeChild(t);
						})(e);
					}
				};
			};
		},
		113: (t) => {
			t.exports = function(t, e) {
				if (e.styleSheet) e.styleSheet.cssText = t;
				else {
					for (; e.firstChild;) e.removeChild(e.firstChild);
					e.appendChild(document.createTextNode(t));
				}
			};
		}
	}, e = {};
	function i(s) {
		var n = e[s];
		if (void 0 !== n) return n.exports;
		var o = e[s] = {
			id: s,
			exports: {}
		};
		return t[s](o, o.exports, i), o.exports;
	}
	i.n = (t) => {
		var e = t && t.__esModule ? () => t.default : () => t;
		return i.d(e, { a: e }), e;
	}, i.d = (t, e) => {
		for (var s in e) i.o(e, s) && !i.o(t, s) && Object.defineProperty(t, s, {
			enumerable: !0,
			get: e[s]
		});
	}, i.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e), i.nc = void 0, (() => {
		function t(t, e, i) {
			const s = document.createElement(e);
			return t && (s.className = t), i && i.appendChild(s), s;
		}
		function e(t, e, i) {
			t.style.width = "number" == typeof e ? `${e}px` : e, t.style.height = "number" == typeof i ? `${i}px` : i;
		}
		const s = "loading", n = "loaded", o = "error";
		function a(t, e, i = document) {
			let s = [];
			if (t instanceof Element) s = [t];
			else if (t instanceof NodeList || Array.isArray(t)) s = Array.from(t);
			else {
				const n = "string" == typeof t ? t : e;
				n && (s = Array.from(i.querySelectorAll(n)));
			}
			return s;
		}
		function r() {
			return !(!navigator.vendor || !navigator.vendor.match(/apple/i));
		}
		class h {
			constructor(t, e) {
				this.type = t, this.defaultPrevented = !1, e && Object.assign(this, e);
			}
			preventDefault() {
				this.defaultPrevented = !0;
			}
		}
		class l {
			constructor() {
				this._listeners = {}, this._filters = {}, this.pswp = void 0, this.options = void 0;
			}
			addFilter(t, e, i = 100) {
				var s, n, o;
				this._filters[t] || (this._filters[t] = []), null === (s = this._filters[t]) || void 0 === s || s.push({
					fn: e,
					priority: i
				}), null === (n = this._filters[t]) || void 0 === n || n.sort((t, e) => t.priority - e.priority), null === (o = this.pswp) || void 0 === o || o.addFilter(t, e, i);
			}
			removeFilter(t, e) {
				this._filters[t] && (this._filters[t] = this._filters[t].filter((t) => t.fn !== e)), this.pswp && this.pswp.removeFilter(t, e);
			}
			applyFilters(t, ...e) {
				var i;
				return null === (i = this._filters[t]) || void 0 === i || i.forEach((t) => {
					e[0] = t.fn.apply(this, e);
				}), e[0];
			}
			on(t, e) {
				var i, s;
				this._listeners[t] || (this._listeners[t] = []), null === (i = this._listeners[t]) || void 0 === i || i.push(e), null === (s = this.pswp) || void 0 === s || s.on(t, e);
			}
			off(t, e) {
				var i;
				this._listeners[t] && (this._listeners[t] = this._listeners[t].filter((t) => e !== t)), null === (i = this.pswp) || void 0 === i || i.off(t, e);
			}
			dispatch(t, e) {
				var i;
				if (this.pswp) return this.pswp.dispatch(t, e);
				const s = new h(t, e);
				return null === (i = this._listeners[t]) || void 0 === i || i.forEach((t) => {
					t.call(this, s);
				}), s;
			}
		}
		class p {
			constructor(e, i) {
				if (this.element = t("pswp__img pswp__img--placeholder", e ? "img" : "div", i), e) {
					const t = this.element;
					t.decoding = "async", t.alt = "", t.src = e, t.setAttribute("role", "presentation");
				}
				this.element.setAttribute("aria-hidden", "true");
			}
			setDisplayedSize(t, i) {
				this.element && ("IMG" === this.element.tagName ? (e(this.element, 250, "auto"), this.element.style.transformOrigin = "0 0", this.element.style.transform = (function(t, e, i) {
					let s = "translate3d(0px,0px,0)";
					return void 0 !== i && (s += ` scale3d(${i},${i},1)`), s;
				})(0, 0, t / 250)) : e(this.element, t, i));
			}
			destroy() {
				var t;
				null !== (t = this.element) && void 0 !== t && t.parentNode && this.element.remove(), this.element = null;
			}
		}
		class d {
			constructor(t, e, i) {
				this.instance = e, this.data = t, this.index = i, this.element = void 0, this.placeholder = void 0, this.slide = void 0, this.displayedImageWidth = 0, this.displayedImageHeight = 0, this.width = Number(this.data.w) || Number(this.data.width) || 0, this.height = Number(this.data.h) || Number(this.data.height) || 0, this.isAttached = !1, this.hasSlide = !1, this.isDecoding = !1, this.state = "idle", this.data.type ? this.type = this.data.type : this.data.src ? this.type = "image" : this.type = "html", this.instance.dispatch("contentInit", { content: this });
			}
			removePlaceholder() {
				this.placeholder && !this.keepPlaceholder() && setTimeout(() => {
					this.placeholder && (this.placeholder.destroy(), this.placeholder = void 0);
				}, 1e3);
			}
			load(e, i) {
				if (this.slide && this.usePlaceholder()) if (this.placeholder) {
					const t = this.placeholder.element;
					t && !t.parentElement && this.slide.container.prepend(t);
				} else {
					const t = this.instance.applyFilters("placeholderSrc", !(!this.data.msrc || !this.slide.isFirstSlide) && this.data.msrc, this);
					this.placeholder = new p(t, this.slide.container);
				}
				this.element && !i || this.instance.dispatch("contentLoad", {
					content: this,
					isLazy: e
				}).defaultPrevented || (this.isImageContent() ? (this.element = t("pswp__img", "img"), this.displayedImageWidth && this.loadImage(e)) : (this.element = t("pswp__content", "div"), this.element.innerHTML = this.data.html || ""), i && this.slide && this.slide.updateContentSize(!0));
			}
			loadImage(t) {
				var e, i;
				if (!this.isImageContent() || !this.element || this.instance.dispatch("contentLoadImage", {
					content: this,
					isLazy: t
				}).defaultPrevented) return;
				const n = this.element;
				this.updateSrcsetSizes(), this.data.srcset && (n.srcset = this.data.srcset), n.src = null !== (e = this.data.src) && void 0 !== e ? e : "", n.alt = null !== (i = this.data.alt) && void 0 !== i ? i : "", this.state = s, n.complete ? this.onLoaded() : (n.onload = () => {
					this.onLoaded();
				}, n.onerror = () => {
					this.onError();
				});
			}
			setSlide(t) {
				this.slide = t, this.hasSlide = !0, this.instance = t.pswp;
			}
			onLoaded() {
				this.state = n, this.slide && this.element && (this.instance.dispatch("loadComplete", {
					slide: this.slide,
					content: this
				}), this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode && (this.append(), this.slide.updateContentSize(!0)), this.state !== n && this.state !== o || this.removePlaceholder());
			}
			onError() {
				this.state = o, this.slide && (this.displayError(), this.instance.dispatch("loadComplete", {
					slide: this.slide,
					isError: !0,
					content: this
				}), this.instance.dispatch("loadError", {
					slide: this.slide,
					content: this
				}));
			}
			isLoading() {
				return this.instance.applyFilters("isContentLoading", this.state === s, this);
			}
			isError() {
				return this.state === o;
			}
			isImageContent() {
				return "image" === this.type;
			}
			setDisplayedSize(t, i) {
				if (this.element && (this.placeholder && this.placeholder.setDisplayedSize(t, i), !this.instance.dispatch("contentResize", {
					content: this,
					width: t,
					height: i
				}).defaultPrevented && (e(this.element, t, i), this.isImageContent() && !this.isError()))) {
					const e = !this.displayedImageWidth && t;
					this.displayedImageWidth = t, this.displayedImageHeight = i, e ? this.loadImage(!1) : this.updateSrcsetSizes(), this.slide && this.instance.dispatch("imageSizeChange", {
						slide: this.slide,
						width: t,
						height: i,
						content: this
					});
				}
			}
			isZoomable() {
				return this.instance.applyFilters("isContentZoomable", this.isImageContent() && this.state !== o, this);
			}
			updateSrcsetSizes() {
				if (!this.isImageContent() || !this.element || !this.data.srcset) return;
				const t = this.element, e = this.instance.applyFilters("srcsetSizesWidth", this.displayedImageWidth, this);
				(!t.dataset.largestUsedSize || e > parseInt(t.dataset.largestUsedSize, 10)) && (t.sizes = e + "px", t.dataset.largestUsedSize = String(e));
			}
			usePlaceholder() {
				return this.instance.applyFilters("useContentPlaceholder", this.isImageContent(), this);
			}
			lazyLoad() {
				this.instance.dispatch("contentLazyLoad", { content: this }).defaultPrevented || this.load(!0);
			}
			keepPlaceholder() {
				return this.instance.applyFilters("isKeepingPlaceholder", this.isLoading(), this);
			}
			destroy() {
				this.hasSlide = !1, this.slide = void 0, this.instance.dispatch("contentDestroy", { content: this }).defaultPrevented || (this.remove(), this.placeholder && (this.placeholder.destroy(), this.placeholder = void 0), this.isImageContent() && this.element && (this.element.onload = null, this.element.onerror = null, this.element = void 0));
			}
			displayError() {
				if (this.slide) {
					var e, i;
					let s = t("pswp__error-msg", "div");
					s.innerText = null !== (e = null === (i = this.instance.options) || void 0 === i ? void 0 : i.errorMsg) && void 0 !== e ? e : "", s = this.instance.applyFilters("contentErrorElement", s, this), this.element = t("pswp__content pswp__error-msg-container", "div"), this.element.appendChild(s), this.slide.container.innerText = "", this.slide.container.appendChild(this.element), this.slide.updateContentSize(!0), this.removePlaceholder();
				}
			}
			append() {
				if (this.isAttached || !this.element) return;
				if (this.isAttached = !0, this.state === o) return void this.displayError();
				if (this.instance.dispatch("contentAppend", { content: this }).defaultPrevented) return;
				const t = "decode" in this.element;
				this.isImageContent() ? t && this.slide && (!this.slide.isActive || r()) ? (this.isDecoding = !0, this.element.decode().catch(() => {}).finally(() => {
					this.isDecoding = !1, this.appendImage();
				})) : this.appendImage() : this.slide && !this.element.parentNode && this.slide.container.appendChild(this.element);
			}
			activate() {
				!this.instance.dispatch("contentActivate", { content: this }).defaultPrevented && this.slide && (this.isImageContent() && this.isDecoding && !r() ? this.appendImage() : this.isError() && this.load(!1, !0), this.slide.holderElement && this.slide.holderElement.setAttribute("aria-hidden", "false"));
			}
			deactivate() {
				this.instance.dispatch("contentDeactivate", { content: this }), this.slide && this.slide.holderElement && this.slide.holderElement.setAttribute("aria-hidden", "true");
			}
			remove() {
				this.isAttached = !1, this.instance.dispatch("contentRemove", { content: this }).defaultPrevented || (this.element && this.element.parentNode && this.element.remove(), this.placeholder && this.placeholder.element && this.placeholder.element.remove());
			}
			appendImage() {
				this.isAttached && (this.instance.dispatch("contentAppendImage", { content: this }).defaultPrevented || (this.slide && this.element && !this.element.parentNode && this.slide.container.appendChild(this.element), this.state !== n && this.state !== o || this.removePlaceholder()));
			}
		}
		function c(t, e, i, s, n) {
			let o = 0;
			if (e.paddingFn) o = e.paddingFn(i, s, n)[t];
			else if (e.padding) o = e.padding[t];
			else {
				const i = "padding" + t[0].toUpperCase() + t.slice(1);
				e[i] && (o = e[i]);
			}
			return Number(o) || 0;
		}
		class m {
			constructor(t, e, i, s) {
				this.pswp = s, this.options = t, this.itemData = e, this.index = i, this.panAreaSize = null, this.elementSize = null, this.fit = 1, this.fill = 1, this.vFill = 1, this.initial = 1, this.secondary = 1, this.max = 1, this.min = 1;
			}
			update(t, e, i) {
				const s = {
					x: t,
					y: e
				};
				this.elementSize = s, this.panAreaSize = i;
				const n = i.x / s.x, o = i.y / s.y;
				this.fit = Math.min(1, n < o ? n : o), this.fill = Math.min(1, n > o ? n : o), this.vFill = Math.min(1, o), this.initial = this._getInitial(), this.secondary = this._getSecondary(), this.max = Math.max(this.initial, this.secondary, this._getMax()), this.min = Math.min(this.fit, this.initial, this.secondary), this.pswp && this.pswp.dispatch("zoomLevelsUpdate", {
					zoomLevels: this,
					slideData: this.itemData
				});
			}
			_parseZoomLevelOption(t) {
				const e = t + "ZoomLevel", i = this.options[e];
				if (i) return "function" == typeof i ? i(this) : "fill" === i ? this.fill : "fit" === i ? this.fit : Number(i);
			}
			_getSecondary() {
				let t = this._parseZoomLevelOption("secondary");
				return t || (t = Math.min(1, 3 * this.fit), this.elementSize && t * this.elementSize.x > 4e3 && (t = 4e3 / this.elementSize.x), t);
			}
			_getInitial() {
				return this._parseZoomLevelOption("initial") || this.fit;
			}
			_getMax() {
				return this._parseZoomLevelOption("max") || Math.max(1, 4 * this.fit);
			}
		}
		function u(t, e, i) {
			const s = e.createContentFromData(t, i);
			let n;
			const { options: o } = e;
			if (o) {
				let a;
				n = new m(o, t, -1), a = e.pswp ? e.pswp.viewportSize : (function(t, e) {
					if (t.getViewportSizeFn) {
						const i = t.getViewportSizeFn(t, e);
						if (i) return i;
					}
					return {
						x: document.documentElement.clientWidth,
						y: window.innerHeight
					};
				})(o, e);
				const r = (function(t, e, i, s) {
					return {
						x: e.x - c("left", t, e, i, s) - c("right", t, e, i, s),
						y: e.y - c("top", t, e, i, s) - c("bottom", t, e, i, s)
					};
				})(o, a, t, i);
				n.update(s.width, s.height, r);
			}
			return s.lazyLoad(), n && s.setDisplayedSize(Math.ceil(s.width * n.initial), Math.ceil(s.height * n.initial)), s;
		}
		class v extends l {
			getNumItems() {
				var t;
				let e = 0;
				const i = null === (t = this.options) || void 0 === t ? void 0 : t.dataSource;
				i && "length" in i ? e = i.length : i && "gallery" in i && (i.items || (i.items = this._getGalleryDOMElements(i.gallery)), i.items && (e = i.items.length));
				const s = this.dispatch("numItems", {
					dataSource: i,
					numItems: e
				});
				return this.applyFilters("numItems", s.numItems, i);
			}
			createContentFromData(t, e) {
				return new d(t, this, e);
			}
			getItemData(t) {
				var e;
				const i = null === (e = this.options) || void 0 === e ? void 0 : e.dataSource;
				let s = {};
				Array.isArray(i) ? s = i[t] : i && "gallery" in i && (i.items || (i.items = this._getGalleryDOMElements(i.gallery)), s = i.items[t]);
				let n = s;
				n instanceof Element && (n = this._domElementToItemData(n));
				const o = this.dispatch("itemData", {
					itemData: n || {},
					index: t
				});
				return this.applyFilters("itemData", o.itemData, t);
			}
			_getGalleryDOMElements(t) {
				var e, i;
				return null !== (e = this.options) && void 0 !== e && e.children || null !== (i = this.options) && void 0 !== i && i.childSelector ? a(this.options.children, this.options.childSelector, t) || [] : [t];
			}
			_domElementToItemData(t) {
				const e = { element: t }, i = "A" === t.tagName ? t : t.querySelector("a");
				if (i) {
					e.src = i.dataset.pswpSrc || i.href, i.dataset.pswpSrcset && (e.srcset = i.dataset.pswpSrcset), e.width = i.dataset.pswpWidth ? parseInt(i.dataset.pswpWidth, 10) : 0, e.height = i.dataset.pswpHeight ? parseInt(i.dataset.pswpHeight, 10) : 0, e.w = e.width, e.h = e.height, i.dataset.pswpType && (e.type = i.dataset.pswpType);
					const n = t.querySelector("img");
					var s;
					n && (e.msrc = n.currentSrc || n.src, e.alt = null !== (s = n.getAttribute("alt")) && void 0 !== s ? s : ""), (i.dataset.pswpCropped || i.dataset.cropped) && (e.thumbCropped = !0);
				}
				return this.applyFilters("domItemData", e, t, i);
			}
			lazyLoadData(t, e) {
				return u(t, this, e);
			}
		}
		var g = i(72), _ = i.n(g), w = i(825), y = i.n(w), f = i(659), x = i.n(f), b = i(56), S = i.n(b), P = i(540), z = i.n(P), C = i(113), I = i.n(C), A = i(619), L = {};
		function T(t, e, i) {
			const s = document.createElement(e);
			return t && (s.className = t), i && i.appendChild(s), s;
		}
		function E(t, e) {
			return t.x = e.x, t.y = e.y, void 0 !== e.id && (t.id = e.id), t;
		}
		function Z(t) {
			t.x = Math.round(t.x), t.y = Math.round(t.y);
		}
		function D(t, e) {
			const i = Math.abs(t.x - e.x), s = Math.abs(t.y - e.y);
			return Math.sqrt(i * i + s * s);
		}
		function O(t, e) {
			return t.x === e.x && t.y === e.y;
		}
		function M(t, e, i) {
			return Math.min(Math.max(t, e), i);
		}
		function F(t, e, i) {
			let s = `translate3d(${t}px,${e || 0}px,0)`;
			return void 0 !== i && (s += ` scale3d(${i},${i},1)`), s;
		}
		function k(t, e, i, s) {
			t.style.transform = F(e, i, s);
		}
		L.styleTagTransform = I(), L.setAttributes = S(), L.insert = x().bind(null, "head"), L.domAPI = y(), L.insertStyleElement = z(), _()(A.A, L), A.A && A.A.locals && A.A.locals;
		function B(t, e, i, s) {
			t.style.transition = e ? `${e} ${i}ms ${s || "cubic-bezier(.4,0,.22,1)"}` : "none";
		}
		function R(t, e, i) {
			t.style.width = "number" == typeof e ? `${e}px` : e, t.style.height = "number" == typeof i ? `${i}px` : i;
		}
		const N = "loading", H = "loaded", W = "error";
		function V() {
			return !(!navigator.vendor || !navigator.vendor.match(/apple/i));
		}
		let U = !1;
		try {
			window.addEventListener("test", null, Object.defineProperty({}, "passive", { get: () => {
				U = !0;
			} }));
		} catch (t) {}
		class q {
			constructor() {
				this._pool = [];
			}
			add(t, e, i, s) {
				this._toggleListener(t, e, i, s);
			}
			remove(t, e, i, s) {
				this._toggleListener(t, e, i, s, !0);
			}
			removeAll() {
				this._pool.forEach((t) => {
					this._toggleListener(t.target, t.type, t.listener, t.passive, !0, !0);
				}), this._pool = [];
			}
			_toggleListener(t, e, i, s, n, o) {
				if (!t) return;
				const a = n ? "removeEventListener" : "addEventListener";
				e.split(" ").forEach((e) => {
					if (e) {
						o || (n ? this._pool = this._pool.filter((s) => s.type !== e || s.listener !== i || s.target !== t) : this._pool.push({
							target: t,
							type: e,
							listener: i,
							passive: s
						}));
						const r = !!U && { passive: s || !1 };
						t[a](e, i, r);
					}
				});
			}
		}
		function G(t, e) {
			if (t.getViewportSizeFn) {
				const i = t.getViewportSizeFn(t, e);
				if (i) return i;
			}
			return {
				x: document.documentElement.clientWidth,
				y: window.innerHeight
			};
		}
		function K(t, e, i, s, n) {
			let o = 0;
			if (e.paddingFn) o = e.paddingFn(i, s, n)[t];
			else if (e.padding) o = e.padding[t];
			else {
				const i = "padding" + t[0].toUpperCase() + t.slice(1);
				e[i] && (o = e[i]);
			}
			return Number(o) || 0;
		}
		function $(t, e, i, s) {
			return {
				x: e.x - K("left", t, e, i, s) - K("right", t, e, i, s),
				y: e.y - K("top", t, e, i, s) - K("bottom", t, e, i, s)
			};
		}
		class j {
			constructor(t) {
				this.slide = t, this.currZoomLevel = 1, this.center = {
					x: 0,
					y: 0
				}, this.max = {
					x: 0,
					y: 0
				}, this.min = {
					x: 0,
					y: 0
				};
			}
			update(t) {
				this.currZoomLevel = t, this.slide.width ? (this._updateAxis("x"), this._updateAxis("y"), this.slide.pswp.dispatch("calcBounds", { slide: this.slide })) : this.reset();
			}
			_updateAxis(t) {
				const { pswp: e } = this.slide, i = this.slide["x" === t ? "width" : "height"] * this.currZoomLevel, s = K("x" === t ? "left" : "top", e.options, e.viewportSize, this.slide.data, this.slide.index), n = this.slide.panAreaSize[t];
				this.center[t] = Math.round((n - i) / 2) + s, this.max[t] = i > n ? Math.round(n - i) + s : this.center[t], this.min[t] = i > n ? s : this.center[t];
			}
			reset() {
				this.center.x = 0, this.center.y = 0, this.max.x = 0, this.max.y = 0, this.min.x = 0, this.min.y = 0;
			}
			correctPan(t, e) {
				return M(e, this.max[t], this.min[t]);
			}
		}
		class X {
			constructor(t, e, i, s) {
				this.pswp = s, this.options = t, this.itemData = e, this.index = i, this.panAreaSize = null, this.elementSize = null, this.fit = 1, this.fill = 1, this.vFill = 1, this.initial = 1, this.secondary = 1, this.max = 1, this.min = 1;
			}
			update(t, e, i) {
				const s = {
					x: t,
					y: e
				};
				this.elementSize = s, this.panAreaSize = i;
				const n = i.x / s.x, o = i.y / s.y;
				this.fit = Math.min(1, n < o ? n : o), this.fill = Math.min(1, n > o ? n : o), this.vFill = Math.min(1, o), this.initial = this._getInitial(), this.secondary = this._getSecondary(), this.max = Math.max(this.initial, this.secondary, this._getMax()), this.min = Math.min(this.fit, this.initial, this.secondary), this.pswp && this.pswp.dispatch("zoomLevelsUpdate", {
					zoomLevels: this,
					slideData: this.itemData
				});
			}
			_parseZoomLevelOption(t) {
				const e = t + "ZoomLevel", i = this.options[e];
				if (i) return "function" == typeof i ? i(this) : "fill" === i ? this.fill : "fit" === i ? this.fit : Number(i);
			}
			_getSecondary() {
				let t = this._parseZoomLevelOption("secondary");
				return t || (t = Math.min(1, 3 * this.fit), this.elementSize && t * this.elementSize.x > 4e3 && (t = 4e3 / this.elementSize.x), t);
			}
			_getInitial() {
				return this._parseZoomLevelOption("initial") || this.fit;
			}
			_getMax() {
				return this._parseZoomLevelOption("max") || Math.max(1, 4 * this.fit);
			}
		}
		class Y {
			constructor(t, e, i) {
				this.data = t, this.index = e, this.pswp = i, this.isActive = e === i.currIndex, this.currentResolution = 0, this.panAreaSize = {
					x: 0,
					y: 0
				}, this.pan = {
					x: 0,
					y: 0
				}, this.isFirstSlide = this.isActive && !i.opener.isOpen, this.zoomLevels = new X(i.options, t, e, i), this.pswp.dispatch("gettingData", {
					slide: this,
					data: this.data,
					index: e
				}), this.content = this.pswp.contentLoader.getContentBySlide(this), this.container = T("pswp__zoom-wrap", "div"), this.holderElement = null, this.currZoomLevel = 1, this.width = this.content.width, this.height = this.content.height, this.heavyAppended = !1, this.bounds = new j(this), this.prevDisplayedWidth = -1, this.prevDisplayedHeight = -1, this.pswp.dispatch("slideInit", { slide: this });
			}
			setIsActive(t) {
				t && !this.isActive ? this.activate() : !t && this.isActive && this.deactivate();
			}
			append(t) {
				this.holderElement = t, this.container.style.transformOrigin = "0 0", this.data && (this.calculateSize(), this.load(), this.updateContentSize(), this.appendHeavy(), this.holderElement.appendChild(this.container), this.zoomAndPanToInitial(), this.pswp.dispatch("firstZoomPan", { slide: this }), this.applyCurrentZoomPan(), this.pswp.dispatch("afterSetContent", { slide: this }), this.isActive && this.activate());
			}
			load() {
				this.content.load(!1), this.pswp.dispatch("slideLoad", { slide: this });
			}
			appendHeavy() {
				const { pswp: t } = this;
				!this.heavyAppended && t.opener.isOpen && !t.mainScroll.isShifted() && (this.isActive, 1) && (this.pswp.dispatch("appendHeavy", { slide: this }).defaultPrevented || (this.heavyAppended = !0, this.content.append(), this.pswp.dispatch("appendHeavyContent", { slide: this })));
			}
			activate() {
				this.isActive = !0, this.appendHeavy(), this.content.activate(), this.pswp.dispatch("slideActivate", { slide: this });
			}
			deactivate() {
				this.isActive = !1, this.content.deactivate(), this.currZoomLevel !== this.zoomLevels.initial && this.calculateSize(), this.currentResolution = 0, this.zoomAndPanToInitial(), this.applyCurrentZoomPan(), this.updateContentSize(), this.pswp.dispatch("slideDeactivate", { slide: this });
			}
			destroy() {
				this.content.hasSlide = !1, this.content.remove(), this.container.remove(), this.pswp.dispatch("slideDestroy", { slide: this });
			}
			resize() {
				this.currZoomLevel !== this.zoomLevels.initial && this.isActive ? (this.calculateSize(), this.bounds.update(this.currZoomLevel), this.panTo(this.pan.x, this.pan.y)) : (this.calculateSize(), this.currentResolution = 0, this.zoomAndPanToInitial(), this.applyCurrentZoomPan(), this.updateContentSize());
			}
			updateContentSize(t) {
				const e = this.currentResolution || this.zoomLevels.initial;
				if (!e) return;
				const i = Math.round(this.width * e) || this.pswp.viewportSize.x, s = Math.round(this.height * e) || this.pswp.viewportSize.y;
				(this.sizeChanged(i, s) || t) && this.content.setDisplayedSize(i, s);
			}
			sizeChanged(t, e) {
				return (t !== this.prevDisplayedWidth || e !== this.prevDisplayedHeight) && (this.prevDisplayedWidth = t, this.prevDisplayedHeight = e, !0);
			}
			getPlaceholderElement() {
				var t;
				return null === (t = this.content.placeholder) || void 0 === t ? void 0 : t.element;
			}
			zoomTo(t, e, i, s) {
				const { pswp: n } = this;
				if (!this.isZoomable() || n.mainScroll.isShifted()) return;
				n.dispatch("beforeZoomTo", {
					destZoomLevel: t,
					centerPoint: e,
					transitionDuration: i
				}), n.animations.stopAllPan();
				const o = this.currZoomLevel;
				s || (t = M(t, this.zoomLevels.min, this.zoomLevels.max)), this.setZoomLevel(t), this.pan.x = this.calculateZoomToPanOffset("x", e, o), this.pan.y = this.calculateZoomToPanOffset("y", e, o), Z(this.pan);
				const a = () => {
					this._setResolution(t), this.applyCurrentZoomPan();
				};
				i ? n.animations.startTransition({
					isPan: !0,
					name: "zoomTo",
					target: this.container,
					transform: this.getCurrentTransform(),
					onComplete: a,
					duration: i,
					easing: n.options.easing
				}) : a();
			}
			toggleZoom(t) {
				this.zoomTo(this.currZoomLevel === this.zoomLevels.initial ? this.zoomLevels.secondary : this.zoomLevels.initial, t, this.pswp.options.zoomAnimationDuration);
			}
			setZoomLevel(t) {
				this.currZoomLevel = t, this.bounds.update(this.currZoomLevel);
			}
			calculateZoomToPanOffset(t, e, i) {
				if (0 == this.bounds.max[t] - this.bounds.min[t]) return this.bounds.center[t];
				e || (e = this.pswp.getViewportCenterPoint()), i || (i = this.zoomLevels.initial);
				const s = this.currZoomLevel / i;
				return this.bounds.correctPan(t, (this.pan[t] - e[t]) * s + e[t]);
			}
			panTo(t, e) {
				this.pan.x = this.bounds.correctPan("x", t), this.pan.y = this.bounds.correctPan("y", e), this.applyCurrentZoomPan();
			}
			isPannable() {
				return Boolean(this.width) && this.currZoomLevel > this.zoomLevels.fit;
			}
			isZoomable() {
				return Boolean(this.width) && this.content.isZoomable();
			}
			applyCurrentZoomPan() {
				this._applyZoomTransform(this.pan.x, this.pan.y, this.currZoomLevel), this === this.pswp.currSlide && this.pswp.dispatch("zoomPanUpdate", { slide: this });
			}
			zoomAndPanToInitial() {
				this.currZoomLevel = this.zoomLevels.initial, this.bounds.update(this.currZoomLevel), E(this.pan, this.bounds.center), this.pswp.dispatch("initialZoomPan", { slide: this });
			}
			_applyZoomTransform(t, e, i) {
				i /= this.currentResolution || this.zoomLevels.initial, k(this.container, t, e, i);
			}
			calculateSize() {
				const { pswp: t } = this;
				E(this.panAreaSize, $(t.options, t.viewportSize, this.data, this.index)), this.zoomLevels.update(this.width, this.height, this.panAreaSize), t.dispatch("calcSlideSize", { slide: this });
			}
			getCurrentTransform() {
				const t = this.currZoomLevel / (this.currentResolution || this.zoomLevels.initial);
				return F(this.pan.x, this.pan.y, t);
			}
			_setResolution(t) {
				t !== this.currentResolution && (this.currentResolution = t, this.updateContentSize(), this.pswp.dispatch("resolutionChanged"));
			}
		}
		class J {
			constructor(t) {
				this.gestures = t, this.pswp = t.pswp, this.startPan = {
					x: 0,
					y: 0
				};
			}
			start() {
				this.pswp.currSlide && E(this.startPan, this.pswp.currSlide.pan), this.pswp.animations.stopAll();
			}
			change() {
				const { p1: t, prevP1: e, dragAxis: i } = this.gestures, { currSlide: s } = this.pswp;
				if ("y" === i && this.pswp.options.closeOnVerticalDrag && s && s.currZoomLevel <= s.zoomLevels.fit && !this.gestures.isMultitouch) {
					const i = s.pan.y + (t.y - e.y);
					if (!this.pswp.dispatch("verticalDrag", { panY: i }).defaultPrevented) {
						this._setPanWithFriction("y", i, .6);
						const t = 1 - Math.abs(this._getVerticalDragRatio(s.pan.y));
						this.pswp.applyBgOpacity(t), s.applyCurrentZoomPan();
					}
				} else this._panOrMoveMainScroll("x") || (this._panOrMoveMainScroll("y"), s && (Z(s.pan), s.applyCurrentZoomPan()));
			}
			end() {
				const { velocity: t } = this.gestures, { mainScroll: e, currSlide: i } = this.pswp;
				let s = 0;
				if (this.pswp.animations.stopAll(), e.isShifted()) {
					const i = (e.x - e.getCurrSlideX()) / this.pswp.viewportSize.x;
					t.x < -.5 && i < 0 || t.x < .1 && i < -.5 ? (s = 1, t.x = Math.min(t.x, 0)) : (t.x > .5 && i > 0 || t.x > -.1 && i > .5) && (s = -1, t.x = Math.max(t.x, 0)), e.moveIndexBy(s, !0, t.x);
				}
				i && i.currZoomLevel > i.zoomLevels.max || this.gestures.isMultitouch ? this.gestures.zoomLevels.correctZoomPan(!0) : (this._finishPanGestureForAxis("x"), this._finishPanGestureForAxis("y"));
			}
			_finishPanGestureForAxis(t) {
				const { velocity: e } = this.gestures, { currSlide: i } = this.pswp;
				if (!i) return;
				const { pan: s, bounds: n } = i, o = s[t], a = this.pswp.bgOpacity < 1 && "y" === t, r = o + .995 * e[t] / .0050000000000000044;
				if (a) {
					const t = this._getVerticalDragRatio(o), e = this._getVerticalDragRatio(r);
					if (t < 0 && e < -.4 || t > 0 && e > .4) return void this.pswp.close();
				}
				const h = n.correctPan(t, r);
				if (o === h) return;
				const l = h === r ? 1 : .82, p = this.pswp.bgOpacity, d = h - o;
				this.pswp.animations.startSpring({
					name: "panGesture" + t,
					isPan: !0,
					start: o,
					end: h,
					velocity: e[t],
					dampingRatio: l,
					onUpdate: (e) => {
						if (a && this.pswp.bgOpacity < 1) {
							const t = 1 - (h - e) / d;
							this.pswp.applyBgOpacity(M(p + (1 - p) * t, 0, 1));
						}
						s[t] = Math.floor(e), i.applyCurrentZoomPan();
					}
				});
			}
			_panOrMoveMainScroll(t) {
				const { p1: e, dragAxis: i, prevP1: s, isMultitouch: n } = this.gestures, { currSlide: o, mainScroll: a } = this.pswp, r = e[t] - s[t], h = a.x + r;
				if (!r || !o) return !1;
				if ("x" === t && !o.isPannable() && !n) return a.moveTo(h, !0), !0;
				const { bounds: l } = o, p = o.pan[t] + r;
				if (this.pswp.options.allowPanToNext && "x" === i && "x" === t && !n) {
					const e = a.getCurrSlideX(), i = a.x - e, s = r > 0, n = !s;
					if (p > l.min[t] && s) {
						if (l.min[t] <= this.startPan[t]) return a.moveTo(h, !0), !0;
						this._setPanWithFriction(t, p);
					} else if (p < l.max[t] && n) {
						if (this.startPan[t] <= l.max[t]) return a.moveTo(h, !0), !0;
						this._setPanWithFriction(t, p);
					} else if (0 !== i) {
						if (i > 0) return a.moveTo(Math.max(h, e), !0), !0;
						if (i < 0) return a.moveTo(Math.min(h, e), !0), !0;
					} else this._setPanWithFriction(t, p);
				} else "y" === t && (a.isShifted() || l.min.y === l.max.y) || this._setPanWithFriction(t, p);
				return !1;
			}
			_getVerticalDragRatio(t) {
				var e, i;
				return (t - (null !== (e = null === (i = this.pswp.currSlide) || void 0 === i ? void 0 : i.bounds.center.y) && void 0 !== e ? e : 0)) / (this.pswp.viewportSize.y / 3);
			}
			_setPanWithFriction(t, e, i) {
				const { currSlide: s } = this.pswp;
				if (!s) return;
				const { pan: n, bounds: o } = s;
				if (o.correctPan(t, e) !== e || i) {
					const s = Math.round(e - n[t]);
					n[t] += s * (i || .35);
				} else n[t] = e;
			}
		}
		function Q(t, e, i) {
			return t.x = (e.x + i.x) / 2, t.y = (e.y + i.y) / 2, t;
		}
		class tt {
			constructor(t) {
				this.gestures = t, this._startPan = {
					x: 0,
					y: 0
				}, this._startZoomPoint = {
					x: 0,
					y: 0
				}, this._zoomPoint = {
					x: 0,
					y: 0
				}, this._wasOverFitZoomLevel = !1, this._startZoomLevel = 1;
			}
			start() {
				const { currSlide: t } = this.gestures.pswp;
				t && (this._startZoomLevel = t.currZoomLevel, E(this._startPan, t.pan)), this.gestures.pswp.animations.stopAllPan(), this._wasOverFitZoomLevel = !1;
			}
			change() {
				const { p1: t, startP1: e, p2: i, startP2: s, pswp: n } = this.gestures, { currSlide: o } = n;
				if (!o) return;
				const a = o.zoomLevels.min, r = o.zoomLevels.max;
				if (!o.isZoomable() || n.mainScroll.isShifted()) return;
				Q(this._startZoomPoint, e, s), Q(this._zoomPoint, t, i);
				let h = 1 / D(e, s) * D(t, i) * this._startZoomLevel;
				if (h > o.zoomLevels.initial + o.zoomLevels.initial / 15 && (this._wasOverFitZoomLevel = !0), h < a) if (n.options.pinchToClose && !this._wasOverFitZoomLevel && this._startZoomLevel <= o.zoomLevels.initial) {
					const t = 1 - (a - h) / (a / 1.2);
					n.dispatch("pinchClose", { bgOpacity: t }).defaultPrevented || n.applyBgOpacity(t);
				} else h = a - .15 * (a - h);
				else h > r && (h = r + .05 * (h - r));
				o.pan.x = this._calculatePanForZoomLevel("x", h), o.pan.y = this._calculatePanForZoomLevel("y", h), o.setZoomLevel(h), o.applyCurrentZoomPan();
			}
			end() {
				const { pswp: t } = this.gestures, { currSlide: e } = t;
				(!e || e.currZoomLevel < e.zoomLevels.initial) && !this._wasOverFitZoomLevel && t.options.pinchToClose ? t.close() : this.correctZoomPan();
			}
			_calculatePanForZoomLevel(t, e) {
				const i = e / this._startZoomLevel;
				return this._zoomPoint[t] - (this._startZoomPoint[t] - this._startPan[t]) * i;
			}
			correctZoomPan(t) {
				const { pswp: e } = this.gestures, { currSlide: i } = e;
				if (null == i || !i.isZoomable()) return;
				0 === this._zoomPoint.x && (t = !0);
				const s = i.currZoomLevel;
				let n, o = !0;
				s < i.zoomLevels.initial ? n = i.zoomLevels.initial : s > i.zoomLevels.max ? n = i.zoomLevels.max : (o = !1, n = s);
				const a = e.bgOpacity, r = e.bgOpacity < 1, h = E({
					x: 0,
					y: 0
				}, i.pan);
				let l = E({
					x: 0,
					y: 0
				}, h);
				t && (this._zoomPoint.x = 0, this._zoomPoint.y = 0, this._startZoomPoint.x = 0, this._startZoomPoint.y = 0, this._startZoomLevel = s, E(this._startPan, h)), o && (l = {
					x: this._calculatePanForZoomLevel("x", n),
					y: this._calculatePanForZoomLevel("y", n)
				}), i.setZoomLevel(n), l = {
					x: i.bounds.correctPan("x", l.x),
					y: i.bounds.correctPan("y", l.y)
				}, i.setZoomLevel(s);
				const p = !O(l, h);
				if (!p && !o && !r) return i._setResolution(n), void i.applyCurrentZoomPan();
				e.animations.stopAllPan(), e.animations.startSpring({
					isPan: !0,
					start: 0,
					end: 1e3,
					velocity: 0,
					dampingRatio: 1,
					naturalFrequency: 40,
					onUpdate: (t) => {
						if (t /= 1e3, p || o) {
							if (p && (i.pan.x = h.x + (l.x - h.x) * t, i.pan.y = h.y + (l.y - h.y) * t), o) {
								const e = s + (n - s) * t;
								i.setZoomLevel(e);
							}
							i.applyCurrentZoomPan();
						}
						r && e.bgOpacity < 1 && e.applyBgOpacity(M(a + (1 - a) * t, 0, 1));
					},
					onComplete: () => {
						i._setResolution(n), i.applyCurrentZoomPan();
					}
				});
			}
		}
		function et(t) {
			return !!t.target.closest(".pswp__container");
		}
		class it {
			constructor(t) {
				this.gestures = t;
			}
			click(t, e) {
				const i = e.target.classList, s = i.contains("pswp__img"), n = i.contains("pswp__item") || i.contains("pswp__zoom-wrap");
				s ? this._doClickOrTapAction("imageClick", t, e) : n && this._doClickOrTapAction("bgClick", t, e);
			}
			tap(t, e) {
				et(e) && this._doClickOrTapAction("tap", t, e);
			}
			doubleTap(t, e) {
				et(e) && this._doClickOrTapAction("doubleTap", t, e);
			}
			_doClickOrTapAction(t, e, i) {
				var s;
				const { pswp: n } = this.gestures, { currSlide: o } = n, a = t + "Action", r = n.options[a];
				if (!n.dispatch(a, {
					point: e,
					originalEvent: i
				}).defaultPrevented) if ("function" != typeof r) switch (r) {
					case "close":
					case "next":
						n[r]();
						break;
					case "zoom":
						o?.toggleZoom(e);
						break;
					case "zoom-or-close":
						null != o && o.isZoomable() && o.zoomLevels.secondary !== o.zoomLevels.initial ? o.toggleZoom(e) : n.options.clickToCloseNonZoomable && n.close();
						break;
					case "toggle-controls": null === (s = this.gestures.pswp.element) || void 0 === s || s.classList.toggle("pswp--ui-visible");
				}
				else r.call(n, e, i);
			}
		}
		class st {
			constructor(t) {
				this.pswp = t, this.dragAxis = null, this.p1 = {
					x: 0,
					y: 0
				}, this.p2 = {
					x: 0,
					y: 0
				}, this.prevP1 = {
					x: 0,
					y: 0
				}, this.prevP2 = {
					x: 0,
					y: 0
				}, this.startP1 = {
					x: 0,
					y: 0
				}, this.startP2 = {
					x: 0,
					y: 0
				}, this.velocity = {
					x: 0,
					y: 0
				}, this._lastStartP1 = {
					x: 0,
					y: 0
				}, this._intervalP1 = {
					x: 0,
					y: 0
				}, this._numActivePoints = 0, this._ongoingPointers = [], this._touchEventEnabled = "ontouchstart" in window, this._pointerEventEnabled = !!window.PointerEvent, this.supportsTouch = this._touchEventEnabled || this._pointerEventEnabled && navigator.maxTouchPoints > 1, this._numActivePoints = 0, this._intervalTime = 0, this._velocityCalculated = !1, this.isMultitouch = !1, this.isDragging = !1, this.isZooming = !1, this.raf = null, this._tapTimer = null, this.supportsTouch || (t.options.allowPanToNext = !1), this.drag = new J(this), this.zoomLevels = new tt(this), this.tapHandler = new it(this), t.on("bindEvents", () => {
					t.events.add(t.scrollWrap, "click", this._onClick.bind(this)), this._pointerEventEnabled ? this._bindEvents("pointer", "down", "up", "cancel") : this._touchEventEnabled ? (this._bindEvents("touch", "start", "end", "cancel"), t.scrollWrap && (t.scrollWrap.ontouchmove = () => {}, t.scrollWrap.ontouchend = () => {})) : this._bindEvents("mouse", "down", "up");
				});
			}
			_bindEvents(t, e, i, s) {
				const { pswp: n } = this, { events: o } = n, a = s ? t + s : "";
				o.add(n.scrollWrap, t + e, this.onPointerDown.bind(this)), o.add(window, t + "move", this.onPointerMove.bind(this)), o.add(window, t + i, this.onPointerUp.bind(this)), a && o.add(n.scrollWrap, a, this.onPointerUp.bind(this));
			}
			onPointerDown(t) {
				const e = "mousedown" === t.type || "mouse" === t.pointerType;
				if (e && t.button > 0) return;
				const { pswp: i } = this;
				i.opener.isOpen ? i.dispatch("pointerDown", { originalEvent: t }).defaultPrevented || (e && (i.mouseDetected(), this._preventPointerEventBehaviour(t, "down")), i.animations.stopAll(), this._updatePoints(t, "down"), 1 === this._numActivePoints && (this.dragAxis = null, E(this.startP1, this.p1)), this._numActivePoints > 1 ? (this._clearTapTimer(), this.isMultitouch = !0) : this.isMultitouch = !1) : t.preventDefault();
			}
			onPointerMove(t) {
				this._preventPointerEventBehaviour(t, "move"), this._numActivePoints && (this._updatePoints(t, "move"), this.pswp.dispatch("pointerMove", { originalEvent: t }).defaultPrevented || (1 !== this._numActivePoints || this.isDragging ? this._numActivePoints > 1 && !this.isZooming && (this._finishDrag(), this.isZooming = !0, this._updateStartPoints(), this.zoomLevels.start(), this._rafStopLoop(), this._rafRenderLoop()) : (this.dragAxis || this._calculateDragDirection(), this.dragAxis && !this.isDragging && (this.isZooming && (this.isZooming = !1, this.zoomLevels.end()), this.isDragging = !0, this._clearTapTimer(), this._updateStartPoints(), this._intervalTime = Date.now(), this._velocityCalculated = !1, E(this._intervalP1, this.p1), this.velocity.x = 0, this.velocity.y = 0, this.drag.start(), this._rafStopLoop(), this._rafRenderLoop()))));
			}
			_finishDrag() {
				this.isDragging && (this.isDragging = !1, this._velocityCalculated || this._updateVelocity(!0), this.drag.end(), this.dragAxis = null);
			}
			onPointerUp(t) {
				this._numActivePoints && (this._updatePoints(t, "up"), this.pswp.dispatch("pointerUp", { originalEvent: t }).defaultPrevented || (0 === this._numActivePoints && (this._rafStopLoop(), this.isDragging ? this._finishDrag() : this.isZooming || this.isMultitouch || this._finishTap(t)), this._numActivePoints < 2 && this.isZooming && (this.isZooming = !1, this.zoomLevels.end(), 1 === this._numActivePoints && (this.dragAxis = null, this._updateStartPoints()))));
			}
			_rafRenderLoop() {
				(this.isDragging || this.isZooming) && (this._updateVelocity(), this.isDragging ? O(this.p1, this.prevP1) || this.drag.change() : O(this.p1, this.prevP1) && O(this.p2, this.prevP2) || this.zoomLevels.change(), this._updatePrevPoints(), this.raf = requestAnimationFrame(this._rafRenderLoop.bind(this)));
			}
			_updateVelocity(t) {
				const e = Date.now(), i = e - this._intervalTime;
				i < 50 && !t || (this.velocity.x = this._getVelocity("x", i), this.velocity.y = this._getVelocity("y", i), this._intervalTime = e, E(this._intervalP1, this.p1), this._velocityCalculated = !0);
			}
			_finishTap(t) {
				const { mainScroll: e } = this.pswp;
				if (e.isShifted()) return void e.moveIndexBy(0, !0);
				if (t.type.indexOf("cancel") > 0) return;
				if ("mouseup" === t.type || "mouse" === t.pointerType) return void this.tapHandler.click(this.startP1, t);
				const i = this.pswp.options.doubleTapAction ? 300 : 0;
				this._tapTimer ? (this._clearTapTimer(), D(this._lastStartP1, this.startP1) < 25 && this.tapHandler.doubleTap(this.startP1, t)) : (E(this._lastStartP1, this.startP1), this._tapTimer = setTimeout(() => {
					this.tapHandler.tap(this.startP1, t), this._clearTapTimer();
				}, i));
			}
			_clearTapTimer() {
				this._tapTimer && (clearTimeout(this._tapTimer), this._tapTimer = null);
			}
			_getVelocity(t, e) {
				const i = this.p1[t] - this._intervalP1[t];
				return Math.abs(i) > 1 && e > 5 ? i / e : 0;
			}
			_rafStopLoop() {
				this.raf && (cancelAnimationFrame(this.raf), this.raf = null);
			}
			_preventPointerEventBehaviour(t, e) {
				this.pswp.applyFilters("preventPointerEvent", !0, t, e) && t.preventDefault();
			}
			_updatePoints(t, e) {
				if (this._pointerEventEnabled) {
					const i = t, s = this._ongoingPointers.findIndex((t) => t.id === i.pointerId);
					"up" === e && s > -1 ? this._ongoingPointers.splice(s, 1) : "down" === e && -1 === s ? this._ongoingPointers.push(this._convertEventPosToPoint(i, {
						x: 0,
						y: 0
					})) : s > -1 && this._convertEventPosToPoint(i, this._ongoingPointers[s]), this._numActivePoints = this._ongoingPointers.length, this._numActivePoints > 0 && E(this.p1, this._ongoingPointers[0]), this._numActivePoints > 1 && E(this.p2, this._ongoingPointers[1]);
				} else {
					const i = t;
					this._numActivePoints = 0, i.type.indexOf("touch") > -1 ? i.touches && i.touches.length > 0 && (this._convertEventPosToPoint(i.touches[0], this.p1), this._numActivePoints++, i.touches.length > 1 && (this._convertEventPosToPoint(i.touches[1], this.p2), this._numActivePoints++)) : (this._convertEventPosToPoint(t, this.p1), "up" === e ? this._numActivePoints = 0 : this._numActivePoints++);
				}
			}
			_updatePrevPoints() {
				E(this.prevP1, this.p1), E(this.prevP2, this.p2);
			}
			_updateStartPoints() {
				E(this.startP1, this.p1), E(this.startP2, this.p2), this._updatePrevPoints();
			}
			_calculateDragDirection() {
				if (this.pswp.mainScroll.isShifted()) this.dragAxis = "x";
				else {
					const t = Math.abs(this.p1.x - this.startP1.x) - Math.abs(this.p1.y - this.startP1.y);
					if (0 !== t) {
						const e = t > 0 ? "x" : "y";
						Math.abs(this.p1[e] - this.startP1[e]) >= 10 && (this.dragAxis = e);
					}
				}
			}
			_convertEventPosToPoint(t, e) {
				return e.x = t.pageX - this.pswp.offset.x, e.y = t.pageY - this.pswp.offset.y, "pointerId" in t ? e.id = t.pointerId : void 0 !== t.identifier && (e.id = t.identifier), e;
			}
			_onClick(t) {
				this.pswp.mainScroll.isShifted() && (t.preventDefault(), t.stopPropagation());
			}
		}
		class nt {
			constructor(t) {
				this.pswp = t, this.x = 0, this.slideWidth = 0, this._currPositionIndex = 0, this._prevPositionIndex = 0, this._containerShiftIndex = -1, this.itemHolders = [];
			}
			resize(t) {
				const { pswp: e } = this, i = Math.round(e.viewportSize.x + e.viewportSize.x * e.options.spacing), s = i !== this.slideWidth;
				s && (this.slideWidth = i, this.moveTo(this.getCurrSlideX())), this.itemHolders.forEach((e, i) => {
					s && k(e.el, (i + this._containerShiftIndex) * this.slideWidth), t && e.slide && e.slide.resize();
				});
			}
			resetPosition() {
				this._currPositionIndex = 0, this._prevPositionIndex = 0, this.slideWidth = 0, this._containerShiftIndex = -1;
			}
			appendHolders() {
				this.itemHolders = [];
				for (let t = 0; t < 3; t++) {
					const e = T("pswp__item", "div", this.pswp.container);
					e.setAttribute("role", "group"), e.setAttribute("aria-roledescription", "slide"), e.setAttribute("aria-hidden", "true"), e.style.display = 1 === t ? "block" : "none", this.itemHolders.push({ el: e });
				}
			}
			canBeSwiped() {
				return this.pswp.getNumItems() > 1;
			}
			moveIndexBy(t, e, i) {
				const { pswp: s } = this;
				let n = s.potentialIndex + t;
				const o = s.getNumItems();
				if (s.canLoop()) {
					n = s.getLoopedIndex(n);
					const e = (t + o) % o;
					t = e <= o / 2 ? e : e - o;
				} else n < 0 ? n = 0 : n >= o && (n = o - 1), t = n - s.potentialIndex;
				s.potentialIndex = n, this._currPositionIndex -= t, s.animations.stopMainScroll();
				const a = this.getCurrSlideX();
				if (e) {
					s.animations.startSpring({
						isMainScroll: !0,
						start: this.x,
						end: a,
						velocity: i || 0,
						naturalFrequency: 30,
						dampingRatio: 1,
						onUpdate: (t) => {
							this.moveTo(t);
						},
						onComplete: () => {
							this.updateCurrItem(), s.appendHeavy();
						}
					});
					let t = s.potentialIndex - s.currIndex;
					if (s.canLoop()) {
						const e = (t + o) % o;
						t = e <= o / 2 ? e : e - o;
					}
					Math.abs(t) > 1 && this.updateCurrItem();
				} else this.moveTo(a), this.updateCurrItem();
				return Boolean(t);
			}
			getCurrSlideX() {
				return this.slideWidth * this._currPositionIndex;
			}
			isShifted() {
				return this.x !== this.getCurrSlideX();
			}
			updateCurrItem() {
				var t;
				const { pswp: e } = this, i = this._prevPositionIndex - this._currPositionIndex;
				if (!i) return;
				this._prevPositionIndex = this._currPositionIndex, e.currIndex = e.potentialIndex;
				let s, n = Math.abs(i);
				n >= 3 && (this._containerShiftIndex += i + (i > 0 ? -3 : 3), n = 3);
				for (let t = 0; t < n; t++) i > 0 ? (s = this.itemHolders.shift(), s && (this.itemHolders[2] = s, this._containerShiftIndex++, k(s.el, (this._containerShiftIndex + 2) * this.slideWidth), e.setContent(s, e.currIndex - n + t + 2))) : (s = this.itemHolders.pop(), s && (this.itemHolders.unshift(s), this._containerShiftIndex--, k(s.el, this._containerShiftIndex * this.slideWidth), e.setContent(s, e.currIndex + n - t - 2)));
				Math.abs(this._containerShiftIndex) > 50 && !this.isShifted() && (this.resetPosition(), this.resize()), e.animations.stopAllPan(), this.itemHolders.forEach((t, e) => {
					t.slide && t.slide.setIsActive(1 === e);
				}), e.currSlide = null === (t = this.itemHolders[1]) || void 0 === t ? void 0 : t.slide, e.contentLoader.updateLazy(i), e.currSlide && e.currSlide.applyCurrentZoomPan(), e.dispatch("change");
			}
			moveTo(t, e) {
				if (!this.pswp.canLoop() && e) {
					let e = (this.slideWidth * this._currPositionIndex - t) / this.slideWidth;
					e += this.pswp.currIndex;
					const i = Math.round(t - this.x);
					(e < 0 && i > 0 || e >= this.pswp.getNumItems() - 1 && i < 0) && (t = this.x + .35 * i);
				}
				this.x = t, this.pswp.container && k(this.pswp.container, t), this.pswp.dispatch("moveMainScroll", {
					x: t,
					dragging: null != e && e
				});
			}
		}
		const ot = {
			Escape: 27,
			z: 90,
			ArrowLeft: 37,
			ArrowUp: 38,
			ArrowRight: 39,
			ArrowDown: 40,
			Tab: 9
		}, at = (t, e) => e ? t : ot[t];
		class rt {
			constructor(t) {
				this.pswp = t, this._wasFocused = !1, t.on("bindEvents", () => {
					t.options.trapFocus && (t.options.initialPointerPos || this._focusRoot(), t.events.add(document, "focusin", this._onFocusIn.bind(this))), t.events.add(document, "keydown", this._onKeyDown.bind(this));
				});
				const e = document.activeElement;
				t.on("destroy", () => {
					t.options.returnFocus && e && this._wasFocused && e.focus();
				});
			}
			_focusRoot() {
				!this._wasFocused && this.pswp.element && (this.pswp.element.focus(), this._wasFocused = !0);
			}
			_onKeyDown(t) {
				const { pswp: e } = this;
				if (e.dispatch("keydown", { originalEvent: t }).defaultPrevented) return;
				if ((function(t) {
					return "button" in t && 1 === t.button || t.ctrlKey || t.metaKey || t.altKey || t.shiftKey;
				})(t)) return;
				let i, s, n = !1;
				const o = "key" in t;
				switch (o ? t.key : t.keyCode) {
					case at("Escape", o):
						e.options.escKey && (i = "close");
						break;
					case at("z", o):
						i = "toggleZoom";
						break;
					case at("ArrowLeft", o):
						s = "x";
						break;
					case at("ArrowUp", o):
						s = "y";
						break;
					case at("ArrowRight", o):
						s = "x", n = !0;
						break;
					case at("ArrowDown", o):
						n = !0, s = "y";
						break;
					case at("Tab", o): this._focusRoot();
				}
				if (s) {
					t.preventDefault();
					const { currSlide: o } = e;
					e.options.arrowKeys && "x" === s && e.getNumItems() > 1 ? i = n ? "next" : "prev" : o && o.currZoomLevel > o.zoomLevels.fit && (o.pan[s] += n ? -80 : 80, o.panTo(o.pan.x, o.pan.y));
				}
				i && (t.preventDefault(), e[i]());
			}
			_onFocusIn(t) {
				const { template: e } = this.pswp;
				e && document !== t.target && e !== t.target && !e.contains(t.target) && e.focus();
			}
		}
		const ht = "cubic-bezier(.4,0,.22,1)";
		class lt {
			constructor(t) {
				var e;
				this.props = t;
				const { target: i, onComplete: s, transform: n, onFinish: o = () => {}, duration: a = 333, easing: r = ht } = t;
				this.onFinish = o;
				const h = n ? "transform" : "opacity", l = null !== (e = t[h]) && void 0 !== e ? e : "";
				this._target = i, this._onComplete = s, this._finished = !1, this._onTransitionEnd = this._onTransitionEnd.bind(this), this._helperTimeout = setTimeout(() => {
					B(i, h, a, r), this._helperTimeout = setTimeout(() => {
						i.addEventListener("transitionend", this._onTransitionEnd, !1), i.addEventListener("transitioncancel", this._onTransitionEnd, !1), this._helperTimeout = setTimeout(() => {
							this._finalizeAnimation();
						}, a + 500), i.style[h] = l;
					}, 30);
				}, 0);
			}
			_onTransitionEnd(t) {
				t.target === this._target && this._finalizeAnimation();
			}
			_finalizeAnimation() {
				this._finished || (this._finished = !0, this.onFinish(), this._onComplete && this._onComplete());
			}
			destroy() {
				this._helperTimeout && clearTimeout(this._helperTimeout), B(this._target), this._target.removeEventListener("transitionend", this._onTransitionEnd, !1), this._target.removeEventListener("transitioncancel", this._onTransitionEnd, !1), this._finished || this._finalizeAnimation();
			}
		}
		class pt {
			constructor(t, e, i) {
				this.velocity = 1e3 * t, this._dampingRatio = e || .75, this._naturalFrequency = i || 12, this._dampedFrequency = this._naturalFrequency, this._dampingRatio < 1 && (this._dampedFrequency *= Math.sqrt(1 - this._dampingRatio * this._dampingRatio));
			}
			easeFrame(t, e) {
				let i, s = 0;
				e /= 1e3;
				const n = Math.E ** (-this._dampingRatio * this._naturalFrequency * e);
				if (1 === this._dampingRatio) i = this.velocity + this._naturalFrequency * t, s = (t + i * e) * n, this.velocity = s * -this._naturalFrequency + i * n;
				else if (this._dampingRatio < 1) {
					i = 1 / this._dampedFrequency * (this._dampingRatio * this._naturalFrequency * t + this.velocity);
					const o = Math.cos(this._dampedFrequency * e), a = Math.sin(this._dampedFrequency * e);
					s = n * (t * o + i * a), this.velocity = s * -this._naturalFrequency * this._dampingRatio + n * (-this._dampedFrequency * t * a + this._dampedFrequency * i * o);
				}
				return s;
			}
		}
		class dt {
			constructor(t) {
				this.props = t, this._raf = 0;
				const { start: e, end: i, velocity: s, onUpdate: n, onComplete: o, onFinish: a = () => {}, dampingRatio: r, naturalFrequency: h } = t;
				this.onFinish = a;
				const l = new pt(s, r, h);
				let p = Date.now(), d = e - i;
				const c = () => {
					this._raf && (d = l.easeFrame(d, Date.now() - p), Math.abs(d) < 1 && Math.abs(l.velocity) < 50 ? (n(i), o && o(), this.onFinish()) : (p = Date.now(), n(d + i), this._raf = requestAnimationFrame(c)));
				};
				this._raf = requestAnimationFrame(c);
			}
			destroy() {
				this._raf >= 0 && cancelAnimationFrame(this._raf), this._raf = 0;
			}
		}
		class ct {
			constructor() {
				this.activeAnimations = [];
			}
			startSpring(t) {
				this._start(t, !0);
			}
			startTransition(t) {
				this._start(t);
			}
			_start(t, e) {
				const i = e ? new dt(t) : new lt(t);
				return this.activeAnimations.push(i), i.onFinish = () => this.stop(i), i;
			}
			stop(t) {
				t.destroy();
				const e = this.activeAnimations.indexOf(t);
				e > -1 && this.activeAnimations.splice(e, 1);
			}
			stopAll() {
				this.activeAnimations.forEach((t) => {
					t.destroy();
				}), this.activeAnimations = [];
			}
			stopAllPan() {
				this.activeAnimations = this.activeAnimations.filter((t) => !t.props.isPan || (t.destroy(), !1));
			}
			stopMainScroll() {
				this.activeAnimations = this.activeAnimations.filter((t) => !t.props.isMainScroll || (t.destroy(), !1));
			}
			isPanRunning() {
				return this.activeAnimations.some((t) => t.props.isPan);
			}
		}
		class mt {
			constructor(t) {
				this.pswp = t, t.events.add(t.element, "wheel", this._onWheel.bind(this));
			}
			_onWheel(t) {
				t.preventDefault();
				const { currSlide: e } = this.pswp;
				let { deltaX: i, deltaY: s } = t;
				if (e && !this.pswp.dispatch("wheel", { originalEvent: t }).defaultPrevented) if (t.ctrlKey || this.pswp.options.wheelToZoom) {
					if (e.isZoomable()) {
						let i = -s;
						1 === t.deltaMode ? i *= .05 : i *= t.deltaMode ? 1 : .002, i = 2 ** i;
						const n = e.currZoomLevel * i;
						e.zoomTo(n, {
							x: t.clientX,
							y: t.clientY
						});
					}
				} else e.isPannable() && (1 === t.deltaMode && (i *= 18, s *= 18), e.panTo(e.pan.x - i, e.pan.y - s));
			}
		}
		class ut {
			constructor(t, e) {
				var i;
				const s = e.name || e.className;
				let n = e.html;
				if (!1 === t.options[s]) return;
				"string" == typeof t.options[s + "SVG"] && (n = t.options[s + "SVG"]), t.dispatch("uiElementCreate", { data: e });
				let o = "";
				e.isButton ? (o += "pswp__button ", o += e.className || `pswp__button--${e.name}`) : o += e.className || `pswp__${e.name}`;
				let a = e.isButton ? e.tagName || "button" : e.tagName || "div";
				a = a.toLowerCase();
				const r = T(o, a);
				if (e.isButton) {
					"button" === a && (r.type = "button");
					let { title: i } = e;
					const { ariaLabel: n } = e;
					"string" == typeof t.options[s + "Title"] && (i = t.options[s + "Title"]), i && (r.title = i);
					const o = n || i;
					o && r.setAttribute("aria-label", o);
				}
				r.innerHTML = (function(t) {
					if ("string" == typeof t) return t;
					if (!t || !t.isCustomSVG) return "";
					const e = t;
					let i = "<svg aria-hidden=\"true\" class=\"pswp__icn\" viewBox=\"0 0 %d %d\" width=\"%d\" height=\"%d\">";
					return i = i.split("%d").join(e.size || 32), e.outlineID && (i += "<use class=\"pswp__icn-shadow\" xlink:href=\"#" + e.outlineID + "\"/>"), i += e.inner, i += "</svg>", i;
				})(n), e.onInit && e.onInit(r, t), e.onClick && (r.onclick = (i) => {
					"string" == typeof e.onClick ? t[e.onClick]() : "function" == typeof e.onClick && e.onClick(i, r, t);
				});
				const h = e.appendTo || "bar";
				let l = t.element;
				"bar" === h ? (t.topBar || (t.topBar = T("pswp__top-bar pswp__hide-on-close", "div", t.scrollWrap)), l = t.topBar) : (r.classList.add("pswp__hide-on-close"), "wrapper" === h && (l = t.scrollWrap)), null === (i = l) || void 0 === i || i.appendChild(t.applyFilters("uiElement", r, e));
			}
		}
		function vt(t, e, i) {
			t.classList.add("pswp__button--arrow"), t.setAttribute("aria-controls", "pswp__items"), e.on("change", () => {
				e.options.loop || (t.disabled = i ? !(e.currIndex < e.getNumItems() - 1) : !(e.currIndex > 0));
			});
		}
		const gt = {
			name: "arrowPrev",
			className: "pswp__button--arrow--prev",
			title: "Previous",
			order: 10,
			isButton: !0,
			appendTo: "wrapper",
			html: {
				isCustomSVG: !0,
				size: 60,
				inner: "<path d=\"M29 43l-3 3-16-16 16-16 3 3-13 13 13 13z\" id=\"pswp__icn-arrow\"/>",
				outlineID: "pswp__icn-arrow"
			},
			onClick: "prev",
			onInit: vt
		}, _t = {
			name: "arrowNext",
			className: "pswp__button--arrow--next",
			title: "Next",
			order: 11,
			isButton: !0,
			appendTo: "wrapper",
			html: {
				isCustomSVG: !0,
				size: 60,
				inner: "<use xlink:href=\"#pswp__icn-arrow\"/>",
				outlineID: "pswp__icn-arrow"
			},
			onClick: "next",
			onInit: (t, e) => {
				vt(t, e, !0);
			}
		}, wt = {
			name: "close",
			title: "Close",
			order: 20,
			isButton: !0,
			html: {
				isCustomSVG: !0,
				inner: "<path d=\"M24 10l-2-2-6 6-6-6-2 2 6 6-6 6 2 2 6-6 6 6 2-2-6-6z\" id=\"pswp__icn-close\"/>",
				outlineID: "pswp__icn-close"
			},
			onClick: "close"
		}, yt = {
			name: "zoom",
			title: "Zoom",
			order: 10,
			isButton: !0,
			html: {
				isCustomSVG: !0,
				inner: "<path d=\"M17.426 19.926a6 6 0 1 1 1.5-1.5L23 22.5 21.5 24l-4.074-4.074z\" id=\"pswp__icn-zoom\"/><path fill=\"currentColor\" class=\"pswp__zoom-icn-bar-h\" d=\"M11 16v-2h6v2z\"/><path fill=\"currentColor\" class=\"pswp__zoom-icn-bar-v\" d=\"M13 12h2v6h-2z\"/>",
				outlineID: "pswp__icn-zoom"
			},
			onClick: "toggleZoom"
		}, ft = {
			name: "preloader",
			appendTo: "bar",
			order: 7,
			html: {
				isCustomSVG: !0,
				inner: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.2 16a5.2 5.2 0 1 1-5.2-5.2V8a8 8 0 1 0 8 8h-2.8Z\" id=\"pswp__icn-loading\"/>",
				outlineID: "pswp__icn-loading"
			},
			onInit: (t, e) => {
				let i, s = null;
				const n = (e) => {
					var s;
					i !== e && (i = e, s = e, t.classList.toggle("pswp__preloader--active", s));
				}, o = () => {
					var t;
					if (null === (t = e.currSlide) || void 0 === t || !t.content.isLoading()) return n(!1), void (s && (clearTimeout(s), s = null));
					s || (s = setTimeout(() => {
						var t;
						n(Boolean(null === (t = e.currSlide) || void 0 === t ? void 0 : t.content.isLoading())), s = null;
					}, e.options.preloaderDelay));
				};
				e.on("change", o), e.on("loadComplete", (t) => {
					e.currSlide === t.slide && o();
				}), e.ui && (e.ui.updatePreloaderVisibility = o);
			}
		}, xt = {
			name: "counter",
			order: 5,
			onInit: (t, e) => {
				e.on("change", () => {
					t.innerText = e.currIndex + 1 + e.options.indexIndicatorSep + e.getNumItems();
				});
			}
		};
		function bt(t, e) {
			t.classList.toggle("pswp--zoomed-in", e);
		}
		class St {
			constructor(t) {
				this.pswp = t, this.isRegistered = !1, this.uiElementsData = [], this.items = [], this.updatePreloaderVisibility = () => {}, this._lastUpdatedZoomLevel = void 0;
			}
			init() {
				const { pswp: t } = this;
				this.isRegistered = !1, this.uiElementsData = [
					wt,
					gt,
					_t,
					yt,
					ft,
					xt
				], t.dispatch("uiRegister"), this.uiElementsData.sort((t, e) => (t.order || 0) - (e.order || 0)), this.items = [], this.isRegistered = !0, this.uiElementsData.forEach((t) => {
					this.registerElement(t);
				}), t.on("change", () => {
					var e;
					null === (e = t.element) || void 0 === e || e.classList.toggle("pswp--one-slide", 1 === t.getNumItems());
				}), t.on("zoomPanUpdate", () => this._onZoomPanUpdate());
			}
			registerElement(t) {
				this.isRegistered ? this.items.push(new ut(this.pswp, t)) : this.uiElementsData.push(t);
			}
			_onZoomPanUpdate() {
				const { template: t, currSlide: e, options: i } = this.pswp;
				if (this.pswp.opener.isClosing || !t || !e) return;
				let { currZoomLevel: s } = e;
				if (this.pswp.opener.isOpen || (s = e.zoomLevels.initial), s === this._lastUpdatedZoomLevel) return;
				this._lastUpdatedZoomLevel = s;
				const n = e.zoomLevels.initial - e.zoomLevels.secondary;
				if (Math.abs(n) < .01 || !e.isZoomable()) return bt(t, !1), void t.classList.remove("pswp--zoom-allowed");
				t.classList.add("pswp--zoom-allowed"), bt(t, (s === e.zoomLevels.initial ? e.zoomLevels.secondary : e.zoomLevels.initial) <= s), "zoom" !== i.imageClickAction && "zoom-or-close" !== i.imageClickAction || t.classList.add("pswp--click-to-zoom");
			}
		}
		class Pt {
			constructor(t, e) {
				this.type = t, this.defaultPrevented = !1, e && Object.assign(this, e);
			}
			preventDefault() {
				this.defaultPrevented = !0;
			}
		}
		class zt {
			constructor() {
				this._listeners = {}, this._filters = {}, this.pswp = void 0, this.options = void 0;
			}
			addFilter(t, e, i = 100) {
				var s, n, o;
				this._filters[t] || (this._filters[t] = []), null === (s = this._filters[t]) || void 0 === s || s.push({
					fn: e,
					priority: i
				}), null === (n = this._filters[t]) || void 0 === n || n.sort((t, e) => t.priority - e.priority), null === (o = this.pswp) || void 0 === o || o.addFilter(t, e, i);
			}
			removeFilter(t, e) {
				this._filters[t] && (this._filters[t] = this._filters[t].filter((t) => t.fn !== e)), this.pswp && this.pswp.removeFilter(t, e);
			}
			applyFilters(t, ...e) {
				var i;
				return null === (i = this._filters[t]) || void 0 === i || i.forEach((t) => {
					e[0] = t.fn.apply(this, e);
				}), e[0];
			}
			on(t, e) {
				var i, s;
				this._listeners[t] || (this._listeners[t] = []), null === (i = this._listeners[t]) || void 0 === i || i.push(e), null === (s = this.pswp) || void 0 === s || s.on(t, e);
			}
			off(t, e) {
				var i;
				this._listeners[t] && (this._listeners[t] = this._listeners[t].filter((t) => e !== t)), null === (i = this.pswp) || void 0 === i || i.off(t, e);
			}
			dispatch(t, e) {
				var i;
				if (this.pswp) return this.pswp.dispatch(t, e);
				const s = new Pt(t, e);
				return null === (i = this._listeners[t]) || void 0 === i || i.forEach((t) => {
					t.call(this, s);
				}), s;
			}
		}
		class Ct {
			constructor(t, e) {
				if (this.element = T("pswp__img pswp__img--placeholder", t ? "img" : "div", e), t) {
					const e = this.element;
					e.decoding = "async", e.alt = "", e.src = t, e.setAttribute("role", "presentation");
				}
				this.element.setAttribute("aria-hidden", "true");
			}
			setDisplayedSize(t, e) {
				this.element && ("IMG" === this.element.tagName ? (R(this.element, 250, "auto"), this.element.style.transformOrigin = "0 0", this.element.style.transform = F(0, 0, t / 250)) : R(this.element, t, e));
			}
			destroy() {
				var t;
				null !== (t = this.element) && void 0 !== t && t.parentNode && this.element.remove(), this.element = null;
			}
		}
		class It {
			constructor(t, e, i) {
				this.instance = e, this.data = t, this.index = i, this.element = void 0, this.placeholder = void 0, this.slide = void 0, this.displayedImageWidth = 0, this.displayedImageHeight = 0, this.width = Number(this.data.w) || Number(this.data.width) || 0, this.height = Number(this.data.h) || Number(this.data.height) || 0, this.isAttached = !1, this.hasSlide = !1, this.isDecoding = !1, this.state = "idle", this.data.type ? this.type = this.data.type : this.data.src ? this.type = "image" : this.type = "html", this.instance.dispatch("contentInit", { content: this });
			}
			removePlaceholder() {
				this.placeholder && !this.keepPlaceholder() && setTimeout(() => {
					this.placeholder && (this.placeholder.destroy(), this.placeholder = void 0);
				}, 1e3);
			}
			load(t, e) {
				if (this.slide && this.usePlaceholder()) if (this.placeholder) {
					const t = this.placeholder.element;
					t && !t.parentElement && this.slide.container.prepend(t);
				} else {
					const t = this.instance.applyFilters("placeholderSrc", !(!this.data.msrc || !this.slide.isFirstSlide) && this.data.msrc, this);
					this.placeholder = new Ct(t, this.slide.container);
				}
				this.element && !e || this.instance.dispatch("contentLoad", {
					content: this,
					isLazy: t
				}).defaultPrevented || (this.isImageContent() ? (this.element = T("pswp__img", "img"), this.displayedImageWidth && this.loadImage(t)) : (this.element = T("pswp__content", "div"), this.element.innerHTML = this.data.html || ""), e && this.slide && this.slide.updateContentSize(!0));
			}
			loadImage(t) {
				var e, i;
				if (!this.isImageContent() || !this.element || this.instance.dispatch("contentLoadImage", {
					content: this,
					isLazy: t
				}).defaultPrevented) return;
				const s = this.element;
				this.updateSrcsetSizes(), this.data.srcset && (s.srcset = this.data.srcset), s.src = null !== (e = this.data.src) && void 0 !== e ? e : "", s.alt = null !== (i = this.data.alt) && void 0 !== i ? i : "", this.state = N, s.complete ? this.onLoaded() : (s.onload = () => {
					this.onLoaded();
				}, s.onerror = () => {
					this.onError();
				});
			}
			setSlide(t) {
				this.slide = t, this.hasSlide = !0, this.instance = t.pswp;
			}
			onLoaded() {
				this.state = H, this.slide && this.element && (this.instance.dispatch("loadComplete", {
					slide: this.slide,
					content: this
				}), this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode && (this.append(), this.slide.updateContentSize(!0)), this.state !== H && this.state !== W || this.removePlaceholder());
			}
			onError() {
				this.state = W, this.slide && (this.displayError(), this.instance.dispatch("loadComplete", {
					slide: this.slide,
					isError: !0,
					content: this
				}), this.instance.dispatch("loadError", {
					slide: this.slide,
					content: this
				}));
			}
			isLoading() {
				return this.instance.applyFilters("isContentLoading", this.state === N, this);
			}
			isError() {
				return this.state === W;
			}
			isImageContent() {
				return "image" === this.type;
			}
			setDisplayedSize(t, e) {
				if (this.element && (this.placeholder && this.placeholder.setDisplayedSize(t, e), !this.instance.dispatch("contentResize", {
					content: this,
					width: t,
					height: e
				}).defaultPrevented && (R(this.element, t, e), this.isImageContent() && !this.isError()))) {
					const i = !this.displayedImageWidth && t;
					this.displayedImageWidth = t, this.displayedImageHeight = e, i ? this.loadImage(!1) : this.updateSrcsetSizes(), this.slide && this.instance.dispatch("imageSizeChange", {
						slide: this.slide,
						width: t,
						height: e,
						content: this
					});
				}
			}
			isZoomable() {
				return this.instance.applyFilters("isContentZoomable", this.isImageContent() && this.state !== W, this);
			}
			updateSrcsetSizes() {
				if (!this.isImageContent() || !this.element || !this.data.srcset) return;
				const t = this.element, e = this.instance.applyFilters("srcsetSizesWidth", this.displayedImageWidth, this);
				(!t.dataset.largestUsedSize || e > parseInt(t.dataset.largestUsedSize, 10)) && (t.sizes = e + "px", t.dataset.largestUsedSize = String(e));
			}
			usePlaceholder() {
				return this.instance.applyFilters("useContentPlaceholder", this.isImageContent(), this);
			}
			lazyLoad() {
				this.instance.dispatch("contentLazyLoad", { content: this }).defaultPrevented || this.load(!0);
			}
			keepPlaceholder() {
				return this.instance.applyFilters("isKeepingPlaceholder", this.isLoading(), this);
			}
			destroy() {
				this.hasSlide = !1, this.slide = void 0, this.instance.dispatch("contentDestroy", { content: this }).defaultPrevented || (this.remove(), this.placeholder && (this.placeholder.destroy(), this.placeholder = void 0), this.isImageContent() && this.element && (this.element.onload = null, this.element.onerror = null, this.element = void 0));
			}
			displayError() {
				if (this.slide) {
					var t, e;
					let i = T("pswp__error-msg", "div");
					i.innerText = null !== (t = null === (e = this.instance.options) || void 0 === e ? void 0 : e.errorMsg) && void 0 !== t ? t : "", i = this.instance.applyFilters("contentErrorElement", i, this), this.element = T("pswp__content pswp__error-msg-container", "div"), this.element.appendChild(i), this.slide.container.innerText = "", this.slide.container.appendChild(this.element), this.slide.updateContentSize(!0), this.removePlaceholder();
				}
			}
			append() {
				if (this.isAttached || !this.element) return;
				if (this.isAttached = !0, this.state === W) return void this.displayError();
				if (this.instance.dispatch("contentAppend", { content: this }).defaultPrevented) return;
				const t = "decode" in this.element;
				this.isImageContent() ? t && this.slide && (!this.slide.isActive || V()) ? (this.isDecoding = !0, this.element.decode().catch(() => {}).finally(() => {
					this.isDecoding = !1, this.appendImage();
				})) : this.appendImage() : this.slide && !this.element.parentNode && this.slide.container.appendChild(this.element);
			}
			activate() {
				!this.instance.dispatch("contentActivate", { content: this }).defaultPrevented && this.slide && (this.isImageContent() && this.isDecoding && !V() ? this.appendImage() : this.isError() && this.load(!1, !0), this.slide.holderElement && this.slide.holderElement.setAttribute("aria-hidden", "false"));
			}
			deactivate() {
				this.instance.dispatch("contentDeactivate", { content: this }), this.slide && this.slide.holderElement && this.slide.holderElement.setAttribute("aria-hidden", "true");
			}
			remove() {
				this.isAttached = !1, this.instance.dispatch("contentRemove", { content: this }).defaultPrevented || (this.element && this.element.parentNode && this.element.remove(), this.placeholder && this.placeholder.element && this.placeholder.element.remove());
			}
			appendImage() {
				this.isAttached && (this.instance.dispatch("contentAppendImage", { content: this }).defaultPrevented || (this.slide && this.element && !this.element.parentNode && this.slide.container.appendChild(this.element), this.state !== H && this.state !== W || this.removePlaceholder()));
			}
		}
		function At(t, e, i) {
			const s = e.createContentFromData(t, i);
			let n;
			const { options: o } = e;
			if (o) {
				let a;
				n = new X(o, t, -1), a = e.pswp ? e.pswp.viewportSize : G(o, e);
				const r = $(o, a, t, i);
				n.update(s.width, s.height, r);
			}
			return s.lazyLoad(), n && s.setDisplayedSize(Math.ceil(s.width * n.initial), Math.ceil(s.height * n.initial)), s;
		}
		class Lt {
			constructor(t) {
				this.pswp = t, this.limit = Math.max(t.options.preload[0] + t.options.preload[1] + 1, 5), this._cachedItems = [];
			}
			updateLazy(t) {
				const { pswp: e } = this;
				if (e.dispatch("lazyLoad").defaultPrevented) return;
				const { preload: i } = e.options, s = void 0 === t || t >= 0;
				let n;
				for (n = 0; n <= i[1]; n++) this.loadSlideByIndex(e.currIndex + (s ? n : -n));
				for (n = 1; n <= i[0]; n++) this.loadSlideByIndex(e.currIndex + (s ? -n : n));
			}
			loadSlideByIndex(t) {
				const e = this.pswp.getLoopedIndex(t);
				let i = this.getContentByIndex(e);
				i || (i = (function(t, e) {
					const i = e.getItemData(t);
					if (!e.dispatch("lazyLoadSlide", {
						index: t,
						itemData: i
					}).defaultPrevented) return At(i, e, t);
				})(e, this.pswp), i && this.addToCache(i));
			}
			getContentBySlide(t) {
				let e = this.getContentByIndex(t.index);
				return e || (e = this.pswp.createContentFromData(t.data, t.index), this.addToCache(e)), e.setSlide(t), e;
			}
			addToCache(t) {
				if (this.removeByIndex(t.index), this._cachedItems.push(t), this._cachedItems.length > this.limit) {
					const t = this._cachedItems.findIndex((t) => !t.isAttached && !t.hasSlide);
					-1 !== t && this._cachedItems.splice(t, 1)[0].destroy();
				}
			}
			removeByIndex(t) {
				const e = this._cachedItems.findIndex((e) => e.index === t);
				-1 !== e && this._cachedItems.splice(e, 1);
			}
			getContentByIndex(t) {
				return this._cachedItems.find((e) => e.index === t);
			}
			destroy() {
				this._cachedItems.forEach((t) => t.destroy()), this._cachedItems = [];
			}
		}
		class Tt extends zt {
			getNumItems() {
				var t;
				let e = 0;
				const i = null === (t = this.options) || void 0 === t ? void 0 : t.dataSource;
				i && "length" in i ? e = i.length : i && "gallery" in i && (i.items || (i.items = this._getGalleryDOMElements(i.gallery)), i.items && (e = i.items.length));
				const s = this.dispatch("numItems", {
					dataSource: i,
					numItems: e
				});
				return this.applyFilters("numItems", s.numItems, i);
			}
			createContentFromData(t, e) {
				return new It(t, this, e);
			}
			getItemData(t) {
				var e;
				const i = null === (e = this.options) || void 0 === e ? void 0 : e.dataSource;
				let s = {};
				Array.isArray(i) ? s = i[t] : i && "gallery" in i && (i.items || (i.items = this._getGalleryDOMElements(i.gallery)), s = i.items[t]);
				let n = s;
				n instanceof Element && (n = this._domElementToItemData(n));
				const o = this.dispatch("itemData", {
					itemData: n || {},
					index: t
				});
				return this.applyFilters("itemData", o.itemData, t);
			}
			_getGalleryDOMElements(t) {
				var e, i;
				return null !== (e = this.options) && void 0 !== e && e.children || null !== (i = this.options) && void 0 !== i && i.childSelector ? (function(t, e, i = document) {
					let s = [];
					if (t instanceof Element) s = [t];
					else if (t instanceof NodeList || Array.isArray(t)) s = Array.from(t);
					else {
						const n = "string" == typeof t ? t : e;
						n && (s = Array.from(i.querySelectorAll(n)));
					}
					return s;
				})(this.options.children, this.options.childSelector, t) || [] : [t];
			}
			_domElementToItemData(t) {
				const e = { element: t }, i = "A" === t.tagName ? t : t.querySelector("a");
				if (i) {
					e.src = i.dataset.pswpSrc || i.href, i.dataset.pswpSrcset && (e.srcset = i.dataset.pswpSrcset), e.width = i.dataset.pswpWidth ? parseInt(i.dataset.pswpWidth, 10) : 0, e.height = i.dataset.pswpHeight ? parseInt(i.dataset.pswpHeight, 10) : 0, e.w = e.width, e.h = e.height, i.dataset.pswpType && (e.type = i.dataset.pswpType);
					const n = t.querySelector("img");
					var s;
					n && (e.msrc = n.currentSrc || n.src, e.alt = null !== (s = n.getAttribute("alt")) && void 0 !== s ? s : ""), (i.dataset.pswpCropped || i.dataset.cropped) && (e.thumbCropped = !0);
				}
				return this.applyFilters("domItemData", e, t, i);
			}
			lazyLoadData(t, e) {
				return At(t, this, e);
			}
		}
		const Et = .003;
		class Zt {
			constructor(t) {
				this.pswp = t, this.isClosed = !0, this.isOpen = !1, this.isClosing = !1, this.isOpening = !1, this._duration = void 0, this._useAnimation = !1, this._croppedZoom = !1, this._animateRootOpacity = !1, this._animateBgOpacity = !1, this._placeholder = void 0, this._opacityElement = void 0, this._cropContainer1 = void 0, this._cropContainer2 = void 0, this._thumbBounds = void 0, this._prepareOpen = this._prepareOpen.bind(this), t.on("firstZoomPan", this._prepareOpen);
			}
			open() {
				this._prepareOpen(), this._start();
			}
			close() {
				if (this.isClosed || this.isClosing || this.isOpening) return;
				const t = this.pswp.currSlide;
				this.isOpen = !1, this.isOpening = !1, this.isClosing = !0, this._duration = this.pswp.options.hideAnimationDuration, t && t.currZoomLevel * t.width >= this.pswp.options.maxWidthToAnimate && (this._duration = 0), this._applyStartProps(), setTimeout(() => {
					this._start();
				}, this._croppedZoom ? 30 : 0);
			}
			_prepareOpen() {
				if (this.pswp.off("firstZoomPan", this._prepareOpen), !this.isOpening) {
					const t = this.pswp.currSlide;
					this.isOpening = !0, this.isClosing = !1, this._duration = this.pswp.options.showAnimationDuration, t && t.zoomLevels.initial * t.width >= this.pswp.options.maxWidthToAnimate && (this._duration = 0), this._applyStartProps();
				}
			}
			_applyStartProps() {
				const { pswp: t } = this, e = this.pswp.currSlide, { options: i } = t;
				var s, n;
				if ("fade" === i.showHideAnimationType ? (i.showHideOpacity = !0, this._thumbBounds = void 0) : "none" === i.showHideAnimationType ? (i.showHideOpacity = !1, this._duration = 0, this._thumbBounds = void 0) : this.isOpening && t._initialThumbBounds ? this._thumbBounds = t._initialThumbBounds : this._thumbBounds = this.pswp.getThumbBounds(), this._placeholder = null == e ? void 0 : e.getPlaceholderElement(), t.animations.stopAll(), this._useAnimation = Boolean(this._duration && this._duration > 50), this._animateZoom = Boolean(this._thumbBounds) && (null == e ? void 0 : e.content.usePlaceholder()) && (!this.isClosing || !t.mainScroll.isShifted()), this._animateZoom ? this._animateRootOpacity = null !== (s = i.showHideOpacity) && void 0 !== s && s : (this._animateRootOpacity = !0, this.isOpening && e && (e.zoomAndPanToInitial(), e.applyCurrentZoomPan())), this._animateBgOpacity = !this._animateRootOpacity && this.pswp.options.bgOpacity > Et, this._opacityElement = this._animateRootOpacity ? t.element : t.bg, !this._useAnimation) return this._duration = 0, this._animateZoom = !1, this._animateBgOpacity = !1, this._animateRootOpacity = !0, void (this.isOpening && (t.element && (t.element.style.opacity = String(Et)), t.applyBgOpacity(1)));
				this._animateZoom && this._thumbBounds && this._thumbBounds.innerRect ? (this._croppedZoom = !0, this._cropContainer1 = this.pswp.container, this._cropContainer2 = null === (n = this.pswp.currSlide) || void 0 === n ? void 0 : n.holderElement, t.container && (t.container.style.overflow = "hidden", t.container.style.width = t.viewportSize.x + "px")) : this._croppedZoom = !1, this.isOpening ? (this._animateRootOpacity ? (t.element && (t.element.style.opacity = String(Et)), t.applyBgOpacity(1)) : (this._animateBgOpacity && t.bg && (t.bg.style.opacity = String(Et)), t.element && (t.element.style.opacity = "1")), this._animateZoom && (this._setClosedStateZoomPan(), this._placeholder && (this._placeholder.style.willChange = "transform", this._placeholder.style.opacity = String(Et)))) : this.isClosing && (t.mainScroll.itemHolders[0] && (t.mainScroll.itemHolders[0].el.style.display = "none"), t.mainScroll.itemHolders[2] && (t.mainScroll.itemHolders[2].el.style.display = "none"), this._croppedZoom && 0 !== t.mainScroll.x && (t.mainScroll.resetPosition(), t.mainScroll.resize()));
			}
			_start() {
				this.isOpening && this._useAnimation && this._placeholder && "IMG" === this._placeholder.tagName ? new Promise((t) => {
					let e = !1, i = !0;
					var s;
					(s = this._placeholder, "decode" in s ? s.decode().catch(() => {}) : s.complete ? Promise.resolve(s) : new Promise((t, e) => {
						s.onload = () => t(s), s.onerror = e;
					})).finally(() => {
						e = !0, i || t(!0);
					}), setTimeout(() => {
						i = !1, e && t(!0);
					}, 50), setTimeout(t, 250);
				}).finally(() => this._initiate()) : this._initiate();
			}
			_initiate() {
				var t, e;
				null === (t = this.pswp.element) || void 0 === t || t.style.setProperty("--pswp-transition-duration", this._duration + "ms"), this.pswp.dispatch(this.isOpening ? "openingAnimationStart" : "closingAnimationStart"), this.pswp.dispatch("initialZoom" + (this.isOpening ? "In" : "Out")), null === (e = this.pswp.element) || void 0 === e || e.classList.toggle("pswp--ui-visible", this.isOpening), this.isOpening ? (this._placeholder && (this._placeholder.style.opacity = "1"), this._animateToOpenState()) : this.isClosing && this._animateToClosedState(), this._useAnimation || this._onAnimationComplete();
			}
			_onAnimationComplete() {
				const { pswp: t } = this;
				if (this.isOpen = this.isOpening, this.isClosed = this.isClosing, this.isOpening = !1, this.isClosing = !1, t.dispatch(this.isOpen ? "openingAnimationEnd" : "closingAnimationEnd"), t.dispatch("initialZoom" + (this.isOpen ? "InEnd" : "OutEnd")), this.isClosed) t.destroy();
				else if (this.isOpen) {
					var e;
					this._animateZoom && t.container && (t.container.style.overflow = "visible", t.container.style.width = "100%"), null === (e = t.currSlide) || void 0 === e || e.applyCurrentZoomPan();
				}
			}
			_animateToOpenState() {
				const { pswp: t } = this;
				this._animateZoom && (this._croppedZoom && this._cropContainer1 && this._cropContainer2 && (this._animateTo(this._cropContainer1, "transform", "translate3d(0,0,0)"), this._animateTo(this._cropContainer2, "transform", "none")), t.currSlide && (t.currSlide.zoomAndPanToInitial(), this._animateTo(t.currSlide.container, "transform", t.currSlide.getCurrentTransform()))), this._animateBgOpacity && t.bg && this._animateTo(t.bg, "opacity", String(t.options.bgOpacity)), this._animateRootOpacity && t.element && this._animateTo(t.element, "opacity", "1");
			}
			_animateToClosedState() {
				const { pswp: t } = this;
				this._animateZoom && this._setClosedStateZoomPan(!0), this._animateBgOpacity && t.bgOpacity > .01 && t.bg && this._animateTo(t.bg, "opacity", "0"), this._animateRootOpacity && t.element && this._animateTo(t.element, "opacity", "0");
			}
			_setClosedStateZoomPan(t) {
				if (!this._thumbBounds) return;
				const { pswp: e } = this, { innerRect: i } = this._thumbBounds, { currSlide: s, viewportSize: n } = e;
				if (this._croppedZoom && i && this._cropContainer1 && this._cropContainer2) {
					const e = -n.x + (this._thumbBounds.x - i.x) + i.w, s = -n.y + (this._thumbBounds.y - i.y) + i.h, o = n.x - i.w, a = n.y - i.h;
					t ? (this._animateTo(this._cropContainer1, "transform", F(e, s)), this._animateTo(this._cropContainer2, "transform", F(o, a))) : (k(this._cropContainer1, e, s), k(this._cropContainer2, o, a));
				}
				s && (E(s.pan, i || this._thumbBounds), s.currZoomLevel = this._thumbBounds.w / s.width, t ? this._animateTo(s.container, "transform", s.getCurrentTransform()) : s.applyCurrentZoomPan());
			}
			_animateTo(t, e, i) {
				if (!this._duration) return void (t.style[e] = i);
				const { animations: s } = this.pswp, n = {
					duration: this._duration,
					easing: this.pswp.options.easing,
					onComplete: () => {
						s.activeAnimations.length || this._onAnimationComplete();
					},
					target: t
				};
				n[e] = i, s.startTransition(n);
			}
		}
		const Dt = {
			allowPanToNext: !0,
			spacing: .1,
			loop: !0,
			pinchToClose: !0,
			closeOnVerticalDrag: !0,
			hideAnimationDuration: 333,
			showAnimationDuration: 333,
			zoomAnimationDuration: 333,
			escKey: !0,
			arrowKeys: !0,
			trapFocus: !0,
			returnFocus: !0,
			maxWidthToAnimate: 4e3,
			clickToCloseNonZoomable: !0,
			imageClickAction: "zoom-or-close",
			bgClickAction: "close",
			tapAction: "toggle-controls",
			doubleTapAction: "zoom",
			indexIndicatorSep: " / ",
			preloaderDelay: 2e3,
			bgOpacity: .8,
			index: 0,
			errorMsg: "The image cannot be loaded",
			preload: [1, 2],
			easing: "cubic-bezier(.4,0,.22,1)"
		};
		new class extends v {
			constructor(t) {
				super(), this.options = t || {}, this._uid = 0, this.shouldOpen = !1, this._preloadedContent = void 0, this.onThumbnailsClick = this.onThumbnailsClick.bind(this);
			}
			init() {
				a(this.options.gallery, this.options.gallerySelector).forEach((t) => {
					t.addEventListener("click", this.onThumbnailsClick, !1);
				});
			}
			onThumbnailsClick(t) {
				if ((function(t) {
					return "button" in t && 1 === t.button || t.ctrlKey || t.metaKey || t.altKey || t.shiftKey;
				})(t) || window.pswp) return;
				let e = {
					x: t.clientX,
					y: t.clientY
				};
				e.x || e.y || (e = null);
				let i = this.getClickedIndex(t);
				i = this.applyFilters("clickedIndex", i, t, this);
				const s = { gallery: t.currentTarget };
				i >= 0 && (t.preventDefault(), this.loadAndOpen(i, s, e));
			}
			getClickedIndex(t) {
				if (this.options.getClickedIndexFn) return this.options.getClickedIndexFn.call(this, t);
				const e = t.target, i = a(this.options.children, this.options.childSelector, t.currentTarget).findIndex((t) => t === e || t.contains(e));
				return -1 !== i ? i : this.options.children || this.options.childSelector ? -1 : 0;
			}
			loadAndOpen(t, e, i) {
				if (window.pswp || !this.options) return !1;
				if (!e && this.options.gallery && this.options.children) {
					const t = a(this.options.gallery);
					t[0] && (e = { gallery: t[0] });
				}
				return this.options.index = t, this.options.initialPointerPos = i, this.shouldOpen = !0, this.preload(t, e), !0;
			}
			preload(t, e) {
				const { options: i } = this;
				e && (i.dataSource = e);
				const s = [], n = typeof i.pswpModule;
				if ("function" == typeof (o = i.pswpModule) && o.prototype && o.prototype.goTo) s.push(Promise.resolve(i.pswpModule));
				else {
					if ("string" === n) throw new Error("pswpModule as string is no longer supported");
					if ("function" !== n) throw new Error("pswpModule is not valid");
					s.push(i.pswpModule());
				}
				var o;
				"function" == typeof i.openPromise && s.push(i.openPromise()), !1 !== i.preloadFirstSlide && t >= 0 && (this._preloadedContent = (function(t, e) {
					const i = e.getItemData(t);
					if (!e.dispatch("lazyLoadSlide", {
						index: t,
						itemData: i
					}).defaultPrevented) return u(i, e, t);
				})(t, this));
				const a = ++this._uid;
				Promise.all(s).then((t) => {
					if (this.shouldOpen) {
						const e = t[0];
						this._openPhotoswipe(e, a);
					}
				});
			}
			_openPhotoswipe(t, e) {
				if (e !== this._uid && this.shouldOpen) return;
				if (this.shouldOpen = !1, window.pswp) return;
				const i = "object" == typeof t ? new t.default(this.options) : new t(this.options);
				this.pswp = i, window.pswp = i, Object.keys(this._listeners).forEach((t) => {
					var e;
					null === (e = this._listeners[t]) || void 0 === e || e.forEach((e) => {
						i.on(t, e);
					});
				}), Object.keys(this._filters).forEach((t) => {
					var e;
					null === (e = this._filters[t]) || void 0 === e || e.forEach((e) => {
						i.addFilter(t, e.fn, e.priority);
					});
				}), this._preloadedContent && (i.contentLoader.addToCache(this._preloadedContent), this._preloadedContent = void 0), i.on("destroy", () => {
					this.pswp = void 0, delete window.pswp;
				}), i.init();
			}
			destroy() {
				var t;
				null === (t = this.pswp) || void 0 === t || t.destroy(), this.shouldOpen = !1, this._listeners = {}, a(this.options.gallery, this.options.gallerySelector).forEach((t) => {
					t.removeEventListener("click", this.onThumbnailsClick, !1);
				});
			}
		}({
			bgOpacity: 1,
			showHideAnimationType: "fade",
			mainClass: "media-modal",
			gallery: "[data-media-modal]",
			children: "a",
			initialZoomLevel: "fit",
			secondaryZoomLevel: 1.5,
			counter: !1,
			zoom: !1,
			maxZoomLevel: 1,
			pswpModule: class extends Tt {
				constructor(t) {
					super(), this.options = this._prepareOptions(t || {}), this.offset = {
						x: 0,
						y: 0
					}, this._prevViewportSize = {
						x: 0,
						y: 0
					}, this.viewportSize = {
						x: 0,
						y: 0
					}, this.bgOpacity = 1, this.currIndex = 0, this.potentialIndex = 0, this.isOpen = !1, this.isDestroying = !1, this.hasMouse = !1, this._initialItemData = {}, this._initialThumbBounds = void 0, this.topBar = void 0, this.element = void 0, this.template = void 0, this.container = void 0, this.scrollWrap = void 0, this.currSlide = void 0, this.events = new q(), this.animations = new ct(), this.mainScroll = new nt(this), this.gestures = new st(this), this.opener = new Zt(this), this.keyboard = new rt(this), this.contentLoader = new Lt(this);
				}
				init() {
					if (this.isOpen || this.isDestroying) return !1;
					this.isOpen = !0, this.dispatch("init"), this.dispatch("beforeOpen"), this._createMainStructure();
					let t = "pswp--open";
					return this.gestures.supportsTouch && (t += " pswp--touch"), this.options.mainClass && (t += " " + this.options.mainClass), this.element && (this.element.className += " " + t), this.currIndex = this.options.index || 0, this.potentialIndex = this.currIndex, this.dispatch("firstUpdate"), this.scrollWheel = new mt(this), (Number.isNaN(this.currIndex) || this.currIndex < 0 || this.currIndex >= this.getNumItems()) && (this.currIndex = 0), this.gestures.supportsTouch || this.mouseDetected(), this.updateSize(), this.offset.y = window.pageYOffset, this._initialItemData = this.getItemData(this.currIndex), this.dispatch("gettingData", {
						index: this.currIndex,
						data: this._initialItemData,
						slide: void 0
					}), this._initialThumbBounds = this.getThumbBounds(), this.dispatch("initialLayout"), this.on("openingAnimationEnd", () => {
						const { itemHolders: t } = this.mainScroll;
						t[0] && (t[0].el.style.display = "block", this.setContent(t[0], this.currIndex - 1)), t[2] && (t[2].el.style.display = "block", this.setContent(t[2], this.currIndex + 1)), this.appendHeavy(), this.contentLoader.updateLazy(), this.events.add(window, "resize", this._handlePageResize.bind(this)), this.events.add(window, "scroll", this._updatePageScrollOffset.bind(this)), this.dispatch("bindEvents");
					}), this.mainScroll.itemHolders[1] && this.setContent(this.mainScroll.itemHolders[1], this.currIndex), this.dispatch("change"), this.opener.open(), this.dispatch("afterInit"), !0;
				}
				getLoopedIndex(t) {
					const e = this.getNumItems();
					return this.options.loop && (t > e - 1 && (t -= e), t < 0 && (t += e)), M(t, 0, e - 1);
				}
				appendHeavy() {
					this.mainScroll.itemHolders.forEach((t) => {
						var e;
						null === (e = t.slide) || void 0 === e || e.appendHeavy();
					});
				}
				goTo(t) {
					this.mainScroll.moveIndexBy(this.getLoopedIndex(t) - this.potentialIndex);
				}
				next() {
					this.goTo(this.potentialIndex + 1);
				}
				prev() {
					this.goTo(this.potentialIndex - 1);
				}
				zoomTo(...t) {
					var e;
					null === (e = this.currSlide) || void 0 === e || e.zoomTo(...t);
				}
				toggleZoom() {
					var t;
					null === (t = this.currSlide) || void 0 === t || t.toggleZoom();
				}
				close() {
					this.opener.isOpen && !this.isDestroying && (this.isDestroying = !0, this.dispatch("close"), this.events.removeAll(), this.opener.close());
				}
				destroy() {
					var t;
					if (!this.isDestroying) return this.options.showHideAnimationType = "none", void this.close();
					this.dispatch("destroy"), this._listeners = {}, this.scrollWrap && (this.scrollWrap.ontouchmove = null, this.scrollWrap.ontouchend = null), null === (t = this.element) || void 0 === t || t.remove(), this.mainScroll.itemHolders.forEach((t) => {
						var e;
						null === (e = t.slide) || void 0 === e || e.destroy();
					}), this.contentLoader.destroy(), this.events.removeAll();
				}
				refreshSlideContent(t) {
					this.contentLoader.removeByIndex(t), this.mainScroll.itemHolders.forEach((e, i) => {
						var s, n;
						let o = (null !== (s = null === (n = this.currSlide) || void 0 === n ? void 0 : n.index) && void 0 !== s ? s : 0) - 1 + i;
						var a;
						this.canLoop() && (o = this.getLoopedIndex(o)), o === t && (this.setContent(e, t, !0), 1 === i && (this.currSlide = e.slide, null === (a = e.slide) || void 0 === a || a.setIsActive(!0)));
					}), this.dispatch("change");
				}
				setContent(t, e, i) {
					if (this.canLoop() && (e = this.getLoopedIndex(e)), t.slide) {
						if (t.slide.index === e && !i) return;
						t.slide.destroy(), t.slide = void 0;
					}
					if (!this.canLoop() && (e < 0 || e >= this.getNumItems())) return;
					t.slide = new Y(this.getItemData(e), e, this), e === this.currIndex && (this.currSlide = t.slide), t.slide.append(t.el);
				}
				getViewportCenterPoint() {
					return {
						x: this.viewportSize.x / 2,
						y: this.viewportSize.y / 2
					};
				}
				updateSize(t) {
					if (this.isDestroying) return;
					const e = G(this.options, this);
					!t && O(e, this._prevViewportSize) || (E(this._prevViewportSize, e), this.dispatch("beforeResize"), E(this.viewportSize, this._prevViewportSize), this._updatePageScrollOffset(), this.dispatch("viewportSize"), this.mainScroll.resize(this.opener.isOpen), !this.hasMouse && window.matchMedia("(any-hover: hover)").matches && this.mouseDetected(), this.dispatch("resize"));
				}
				applyBgOpacity(t) {
					this.bgOpacity = Math.max(t, 0), this.bg && (this.bg.style.opacity = String(this.bgOpacity * this.options.bgOpacity));
				}
				mouseDetected() {
					var t;
					this.hasMouse || (this.hasMouse = !0, null === (t = this.element) || void 0 === t || t.classList.add("pswp--has_mouse"));
				}
				_handlePageResize() {
					this.updateSize(), /iPhone|iPad|iPod/i.test(window.navigator.userAgent) && setTimeout(() => {
						this.updateSize();
					}, 500);
				}
				_updatePageScrollOffset() {
					this.setScrollOffset(0, window.pageYOffset);
				}
				setScrollOffset(t, e) {
					this.offset.x = t, this.offset.y = e, this.dispatch("updateScrollOffset");
				}
				_createMainStructure() {
					this.element = T("pswp", "div"), this.element.setAttribute("tabindex", "-1"), this.element.setAttribute("role", "dialog"), this.template = this.element, this.bg = T("pswp__bg", "div", this.element), this.scrollWrap = T("pswp__scroll-wrap", "section", this.element), this.container = T("pswp__container", "div", this.scrollWrap), this.scrollWrap.setAttribute("aria-roledescription", "carousel"), this.container.setAttribute("aria-live", "off"), this.container.setAttribute("id", "pswp__items"), this.mainScroll.appendHolders(), this.ui = new St(this), this.ui.init(), (this.options.appendToEl || document.body).appendChild(this.element);
				}
				getThumbBounds() {
					return (function(t, e, i) {
						const s = i.dispatch("thumbBounds", {
							index: t,
							itemData: e,
							instance: i
						});
						if (s.thumbBounds) return s.thumbBounds;
						const { element: n } = e;
						let o, a;
						if (n && !1 !== i.options.thumbSelector) {
							const t = i.options.thumbSelector || "img";
							a = n.matches(t) ? n : n.querySelector(t);
						}
						return a = i.applyFilters("thumbEl", a, e, t), a && (o = e.thumbCropped ? (function(t, e, i) {
							const s = t.getBoundingClientRect(), n = s.width / e, o = s.height / i, a = n > o ? n : o, r = (s.width - e * a) / 2, h = (s.height - i * a) / 2, l = {
								x: s.left + r,
								y: s.top + h,
								w: e * a
							};
							return l.innerRect = {
								w: s.width,
								h: s.height,
								x: r,
								y: h
							}, l;
						})(a, e.width || e.w || 0, e.height || e.h || 0) : (function(t) {
							const e = t.getBoundingClientRect();
							return {
								x: e.left,
								y: e.top,
								w: e.width
							};
						})(a)), i.applyFilters("thumbBounds", o, e, t);
					})(this.currIndex, this.currSlide ? this.currSlide.data : this._initialItemData, this);
				}
				canLoop() {
					return this.options.loop && this.getNumItems() > 2;
				}
				_prepareOptions(t) {
					return window.matchMedia("(prefers-reduced-motion), (update: slow)").matches && (t.showHideAnimationType = "none", t.zoomAnimationDuration = 0), {
						...Dt,
						...t
					};
				}
			}
		}).init();
	})();
})();
//#endregion
